var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.33,
    y: 306.19,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.47,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.47,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.87,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.87,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.03,
    y: 306.19,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "261.09 306.19 261.09 404.44 266.17 404.44 266.17 398.94 412.07 398.94 412.07 404.44 417.15 404.44 417.15 306.19 261.09 306.19",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100.39 306.19 100.39 404.44 105.47 404.44 105.47 398.94 251.36 398.94 251.36 404.44 256.44 404.44 256.44 306.19 100.39 306.19",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.17,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.17,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-16--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.57,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-17--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.57,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-18--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.3 315.61 284.86 315.61 284.86 309.98 352.3 309.98 352.3 312.66 352.3 315.61",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-19--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.92,320.63h36.75s49.08,21.94,47.17,31.57-35.2,59.05-35.2,59.05l-10.94-7.91s15.72-36.79,24-47c0,0-9-1.83-25.25-7.54h-29C161.58,348.76,152.17,347.46,158.92,320.63Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-20--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.09,399.05l11.43,8.34a1.17,1.17,0,0,1,.18,1.74l-1.06,1.16-1.23,2.09a1.18,1.18,0,0,1-1.69.36L195,404.48a1.18,1.18,0,0,1-.11-1.83l2.14-1.95.17-.91A1.17,1.17,0,0,1,199.09,399.05Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-21--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.47,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-22--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.67,410.34l14.07-1.53A1.18,1.18,0,0,1,264,410v1.57l.49,2.37a1.17,1.17,0,0,1-1,1.41l-14.18,1.76a1.18,1.18,0,0,1-1.32-1.28l.27-2.89-.49-.78A1.18,1.18,0,0,1,248.67,410.34Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-23--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "264.33 166.66 251.22 183.74 229.87 180.93 242.98 163.85 264.33 166.66",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-24--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.31 145.36 219.19 162.44 229.87 180.93 242.98 163.85 232.31 145.36",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-25--inject-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "251.22 183.74 259.46 203.64 238.11 200.83 229.87 180.93 251.22 183.74",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-26--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.62,126.34a12,12,0,1,1-22.07-9.6Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-27--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.56,
    y: 88.75,
    width: 16.43,
    height: 16.43,
    transform: "translate(151.39 -171.55) rotate(45)",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-28--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.79,103a30.27,30.27,0,0,0-60.12,7.1c1.42,12,12,19.06,19.15,27.88,2.23,2.73,3.33,13.8,3.33,13.8l25.49-3s-1.51-11,0-14.19C185.59,124.33,194.21,115,192.79,103Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-29--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.89,104.84s-24.08-25.78-13-33.61S387.89,104.84,387.89,104.84Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-30--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.7,182.49s-24.84,1.75-24.22-7.78S225.7,182.49,225.7,182.49Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-31--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.71,128.12s6.34-14.29,11.62-10.89S402.71,128.12,402.71,128.12Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-32--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.47,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-33--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.5,129.74s-13.42-8-9.41-12.85S391.5,129.74,391.5,129.74Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-34--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-35--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.86,404.94h-9.53a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5h9.53a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,265.86,404.94Zm-9-1h8.53V306.69h-8.53Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-36--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.44,404.94h-5.08a.5.5,0,0,1-.5-.5v-5H106v5a.5.5,0,0,1-.5.5h-5.08a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5H256.44a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,256.44,404.94Zm-4.58-1h4.08V306.69h-155v97.25H105v-5a.5.5,0,0,1,.5-.5H251.36a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-12--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-37--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,390.54H105.47a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,176,390.54Zm-70-1h69.49V354.79H106Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-21--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-38--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,349.71H105.47a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,176,349.71Zm-70-1h69.49V315.58H106Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-32--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-39--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.36,390.54H180.87a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h70.49a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,251.36,390.54Zm-70-1h69.49V354.79H181.37Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-34--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-40--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.36,349.71H180.87a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5h70.49a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,251.36,349.71Zm-70-1h69.49V315.58H181.37Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-2--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-41--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,390.54H125.47a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,176,390.54Zm-50-1h49.49V354.79H126Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-3--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-42--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,349.71H125.47a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,176,349.71Zm-50-1h49.49V315.58H126Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-4--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-43--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.36,390.54H200.87a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h50.49a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,251.36,390.54Zm-50-1h49.49V354.79H201.37Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-5--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-44--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.36,349.71H200.87a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5h50.49a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,251.36,349.71Zm-50-1h49.49V315.58H201.37Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-6--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-45--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.56,404.94H417a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5h9.53a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,426.56,404.94Zm-9-1h8.53V306.69h-8.53Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-7--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-46--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.15,404.94h-5.08a.5.5,0,0,1-.5-.5v-5H266.67v5a.5.5,0,0,1-.5.5h-5.08a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5H417.15a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,417.15,404.94Zm-4.58-1h4.08V306.69H261.59v97.25h4.08v-5a.5.5,0,0,1,.5-.5h145.9a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-8--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-47--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.67,390.54h-70.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h70.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,336.67,390.54Zm-70-1h69.5V354.79h-69.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-9--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-48--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.67,349.71h-70.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h70.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,336.67,349.71Zm-70-1h69.5V315.58h-69.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-10--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-49--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.07,390.54h-70.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h70.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,412.07,390.54Zm-70-1h69.5V354.79h-69.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-11--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-50--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.07,349.71h-70.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h70.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,412.07,349.71Zm-70-1h69.5V315.58h-69.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-13--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-51--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.67,390.54h-50.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h50.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,336.67,390.54Zm-50-1h49.5V354.79h-49.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-14--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-52--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.67,349.71h-50.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h50.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,336.67,349.71Zm-50-1h49.5V315.58h-49.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-15--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-53--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.07,390.54h-50.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h50.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,412.07,390.54Zm-50-1h49.5V354.79h-49.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-16--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-54--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.07,349.71h-50.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h50.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,412.07,349.71Zm-50-1h49.5V315.58h-49.5Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-17--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-55--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.3,316.11H284.86a.5.5,0,0,1-.5-.5V310a.5.5,0,0,1,.5-.5H352.3a.5.5,0,0,1,.5.5v5.63A.5.5,0,0,1,352.3,316.11Zm-66.94-1H351.8v-4.63H285.36Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-18--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-56--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.46,275.4c-3.17,0-5.75-3.59-5.75-8s2.58-8,5.75-8,5.75,3.59,5.75,8S332.63,275.4,329.46,275.4Zm0-15c-2.62,0-4.75,3.14-4.75,7s2.13,7,4.75,7,4.75-3.14,4.75-7S332.08,260.4,329.46,260.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-57--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.64,411.75a.5.5,0,0,1-.29-.09l-10.94-7.92a.5.5,0,0,1-.17-.6c.63-1.47,15.24-35.58,23.54-46.52a236.2,236.2,0,0,1-24.44-7.36H166.4c-2.47,0-5.6-.36-7.81-3.2-3.3-4.24-3.36-12.84-.16-25.55a.51.51,0,0,1,.49-.38h36.75a.45.45,0,0,1,.2,0c2,.91,49.43,22.22,47.46,32.13-1.92,9.62-33.91,57.21-35.27,59.23a.52.52,0,0,1-.33.21Zm-10.32-8.58,10.2,7.37c3.26-4.87,33-49.48,34.83-58.44,1.5-7.56-33.17-24.88-46.79-31H159.31c-3,12.19-3,20.37.07,24.32,1.94,2.49,4.77,2.81,7,2.81h29a.51.51,0,0,1,.17,0c16,5.63,25.09,7.5,25.18,7.52a.48.48,0,0,1,.37.32.54.54,0,0,1-.08.48C213.38,366.15,199,399.3,197.32,403.17Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-19--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-58--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.4,413.45a1.66,1.66,0,0,1-1-.3l-11.68-8.26a1.63,1.63,0,0,1-.7-1.27,1.68,1.68,0,0,1,.54-1.34l2-1.83.13-.75a1.68,1.68,0,0,1,2.64-1.06h0L210.82,407a1.67,1.67,0,0,1,.25,2.48l-1,1.12-1.21,2a1.72,1.72,0,0,1-1.09.79Zm-9-14.13a.6.6,0,0,0-.26.05.65.65,0,0,0-.41.51l-.16.91a.5.5,0,0,1-.16.28L195.26,403a.7.7,0,0,0-.22.54.71.71,0,0,0,.29.52L207,412.33a.69.69,0,0,0,.54.11.68.68,0,0,0,.44-.32l1.23-2.09.06-.08,1.06-1.15a.68.68,0,0,0,.17-.53.71.71,0,0,0-.27-.48l-11.44-8.34A.63.63,0,0,0,198.4,399.32Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-20--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-59--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.19,417.6a1.68,1.68,0,0,1-1.67-1.84l.26-2.71-.41-.64a1.68,1.68,0,0,1,1.24-2.56h0l14.07-1.53a1.68,1.68,0,0,1,1.86,1.66v1.52l.48,2.32a1.68,1.68,0,0,1-1.43,2l-14.19,1.76Zm-.47-6.76a.68.68,0,0,0-.5,1l.49.78a.48.48,0,0,1,.08.31l-.27,2.89a.68.68,0,0,0,.2.55.66.66,0,0,0,.55.18l14.19-1.76a.67.67,0,0,0,.47-.27A.69.69,0,0,0,264,414l-.49-2.37a.34.34,0,0,1,0-.1V410a.67.67,0,0,0-.75-.67Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-22--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-60--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.22,184.24h-.06l-21.35-2.81a.51.51,0,0,1-.4-.31.49.49,0,0,1,.07-.49l13.11-17.09a.5.5,0,0,1,.46-.19l21.35,2.81a.47.47,0,0,1,.39.31.48.48,0,0,1-.06.49l-13.11,17.09A.51.51,0,0,1,251.22,184.24Zm-20.42-3.69,20.2,2.66L263.41,167l-20.21-2.66Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-23--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-61--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.87,181.43h0a.48.48,0,0,1-.4-.25l-10.68-18.49a.48.48,0,0,1,0-.55l13.11-17.09a.51.51,0,0,1,.43-.19.5.5,0,0,1,.4.25l10.68,18.49a.5.5,0,0,1,0,.55l-13.11,17.09A.51.51,0,0,1,229.87,181.43Zm-10.08-19L229.93,180l12.45-16.22-10.13-17.55Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-24--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-62--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.46,204.14h-.06l-21.35-2.81a.5.5,0,0,1-.4-.3l-8.24-19.9a.49.49,0,0,1,.07-.49.46.46,0,0,1,.46-.19l21.35,2.81a.49.49,0,0,1,.39.3l8.25,19.9a.51.51,0,0,1-.07.49A.48.48,0,0,1,259.46,204.14Zm-21-3.77L258.67,203l-7.8-18.83-20.2-2.66Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-25--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-63--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.57,134.08a12.54,12.54,0,0,1-11.48-17.54.49.49,0,0,1,.27-.26.53.53,0,0,1,.39,0l22.07,9.6a.5.5,0,0,1,.26.66A12.55,12.55,0,0,1,266.57,134.08Zm-10.75-16.67A11.53,11.53,0,0,0,277,126.59Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-26--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-64--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.77,109.09a.51.51,0,0,1-.35-.15L270.8,97.32a.51.51,0,0,1,0-.71L282.42,85a.5.5,0,0,1,.71,0l11.62,11.61a.51.51,0,0,1,0,.71l-11.62,11.62A.53.53,0,0,1,282.77,109.09ZM271.86,97l10.91,10.91L293.69,97,282.77,86.06Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-27--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-65--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.15,152.28a.49.49,0,0,1-.5-.45c0-.11-1.11-11-3.21-13.53-1.91-2.34-4.1-4.6-6.22-6.79-5.89-6.08-12-12.36-13-21.35a30.77,30.77,0,1,1,61.11-7.22h0c1.06,9-3.4,16.52-7.72,23.81-1.55,2.62-3.15,5.32-4.46,8-1.44,3,0,13.8,0,13.91a.49.49,0,0,1-.1.37.47.47,0,0,1-.34.19l-25.5,3Zm7.64-75.5a30.32,30.32,0,0,0-3.55.21A29.79,29.79,0,0,0,133.17,110c1,8.66,7,14.82,12.77,20.78,2.13,2.2,4.34,4.47,6.27,6.85s3.13,11.31,3.38,13.55l24.49-2.89c-.28-2.24-1.27-11.06.13-14s2.94-5.49,4.5-8.12c4.23-7.14,8.6-14.52,7.58-23.18h0a29.76,29.76,0,0,0-29.5-26.28Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-28--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-66--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.46,106.18l-.93-1c-.7-.74-17.1-18.43-16-29a7.24,7.24,0,0,1,3.06-5.35,4.38,4.38,0,0,1,4.65-.67c7.61,3.71,9.11,33.41,9.17,34.67ZM377.52,70.75a4.12,4.12,0,0,0-2.37.89,6.13,6.13,0,0,0-2.64,4.64c-.89,8.69,11.26,23.16,14.8,27.17-.4-6-2.34-29.39-8.53-32.4A2.84,2.84,0,0,0,377.52,70.75Z",
    style: {
      clipPath: "url(#freepik--clip-path-29--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-67--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.21,183.13c-5.62,0-14.9-.6-18.61-4.28a5.21,5.21,0,0,1-1.62-4.17,3.22,3.22,0,0,1,1.78-3c5.49-2.57,22.51,9.85,23.23,10.38l1.1.81-1.36.09C225.51,183,223.73,183.13,221.21,183.13Zm-16.58-10.79a3.38,3.38,0,0,0-1.45.27,2.26,2.26,0,0,0-1.2,2.13,4.23,4.23,0,0,0,1.32,3.4c4.19,4.16,16.7,4.08,20.94,3.92C219.32,178.6,209.4,172.34,204.63,172.34Z",
    style: {
      clipPath: "url(#freepik--clip-path-30--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-68--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.73,129.11l.52-1.19c.19-.41,4.55-10.14,9.24-11.54a3.65,3.65,0,0,1,3.12.42,2.29,2.29,0,0,1,1.24,2.16c-.3,3.9-11.64,9-12.94,9.62Zm10.9-11.91a2.85,2.85,0,0,0-.85.14c-3.33,1-6.69,7.09-8,9.75,3.89-1.86,10.9-5.7,11.09-8.2,0-.3,0-.76-.79-1.24A2.54,2.54,0,0,0,412.63,117.2Z",
    style: {
      clipPath: "url(#freepik--clip-path-31--inject-53)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-69--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.36,130.83l-1.11-.66c-.39-.23-9.52-5.74-10.35-10.56a3.63,3.63,0,0,1,.8-3,2.31,2.31,0,0,1,2.3-1c3.83.77,7.57,12.65,8,14Zm-8.78-14.28a1.45,1.45,0,0,0-1.11.66,2.6,2.6,0,0,0-.58,2.23c.59,3.42,6.23,7.49,8.71,9.13-1.37-4.09-4.34-11.51-6.8-12Z",
    style: {
      clipPath: "url(#freepik--clip-path-33--inject-53)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.91,243.17C25.34,292.89,47.77,338,68.8,359.64c34.36,35.39,65.12,31.36,86.79,25,42-12.31,111.19-55.76,149.59-47.65,31.6,6.68,53.94,44.94,74.75,55.27s36.18,3.69,56-15.64C490.39,323.56,466.11,181,415.81,175c-37.2-4.43-86,62.4-119.39,53.5-31.2-8.32-44.48-84.13-97.56-106.13C152.2,103,53.45,172.09,36.91,243.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91,243.17C25.34,292.89,47.77,338,68.8,359.64c34.36,35.39,65.12,31.36,86.79,25,42-12.31,111.19-55.76,149.59-47.65,31.6,6.68,53.94,44.94,74.75,55.27s36.18,3.69,56-15.64C490.39,323.56,466.11,181,415.81,175c-37.2-4.43-86,62.4-119.39,53.5-31.2-8.32-44.48-84.13-97.56-106.13C152.2,103,53.45,172.09,36.91,243.17Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-53"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.61,
    cy: 432.03,
    rx: 114.26,
    ry: 18.06,
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.78,404.76H46.22a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H459.78a.5.5,0,0,1,.5.5A.5.5,0,0,1,459.78,404.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.33,
    y: 306.19,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.86,404.94h-9.53a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5h9.53a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,265.86,404.94Zm-9-1h8.53V306.69h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-35--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.33,
    y: 306.19,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.46,
    y: 397.94,
    width: 9.53,
    height: 6.5,
    transform: "translate(220.45 802.38) rotate(180)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,404.94h-9.53a.5.5,0,0,1-.5-.5v-6.5a.5.5,0,0,1,.5-.5H115a.5.5,0,0,1,.5.5v6.5A.5.5,0,0,1,115,404.94Zm-9-1h8.53v-5.5H106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.39 306.19 100.39 404.44 105.47 404.44 105.47 398.94 251.36 398.94 251.36 404.44 256.44 404.44 256.44 306.19 100.39 306.19",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44,404.94h-5.08a.5.5,0,0,1-.5-.5v-5H106v5a.5.5,0,0,1-.5.5h-5.08a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5H256.44a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,256.44,404.94Zm-4.58-1h4.08V306.69h-155v97.25H105v-5a.5.5,0,0,1,.5-.5H251.36a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-36--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100.39 306.19 100.39 404.44 105.47 404.44 105.47 398.94 251.36 398.94 251.36 404.44 256.44 404.44 256.44 306.19 100.39 306.19",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.47,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,390.54H105.47a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,176,390.54Zm-70-1h69.49V354.79H106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-37--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.47,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.47,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,349.71H105.47a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,176,349.71Zm-70-1h69.49V315.58H106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-38--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.47,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.36,390.54H180.87a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h70.49a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,251.36,390.54Zm-70-1h69.49V354.79H181.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-39--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.36,349.71H180.87a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5h70.49a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,251.36,349.71Zm-70-1h69.49V315.58H181.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-40--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125.47,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,390.54H125.47a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,176,390.54Zm-50-1h49.49V354.79H126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-41--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.47,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125.47,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,349.71H125.47a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5H176a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,176,349.71Zm-50-1h49.49V315.58H126Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-42--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.47,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 200.87,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.36,390.54H200.87a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h50.49a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,251.36,390.54Zm-50-1h49.49V354.79H201.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-43--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.87,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 200.87,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.36,349.71H200.87a.5.5,0,0,1-.5-.5V315.08a.5.5,0,0,1,.5-.5h50.49a.5.5,0,0,1,.5.5v34.13A.5.5,0,0,1,251.36,349.71Zm-50-1h49.49V315.58H201.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-44--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.87,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 417.03,
    y: 306.19,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.56,404.94H417a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5h9.53a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,426.56,404.94Zm-9-1h8.53V306.69h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-45--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.03,
    y: 306.19,
    width: 9.53,
    height: 98.25,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 397.94,
    width: 9.53,
    height: 6.5,
    transform: "translate(541.86 802.38) rotate(180)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,404.94h-9.53a.5.5,0,0,1-.5-.5v-6.5a.5.5,0,0,1,.5-.5h9.53a.5.5,0,0,1,.5.5v6.5A.5.5,0,0,1,275.7,404.94Zm-9-1h8.53v-5.5h-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.09 306.19 261.09 404.44 266.17 404.44 266.17 398.94 412.07 398.94 412.07 404.44 417.15 404.44 417.15 306.19 261.09 306.19",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.15,404.94h-5.08a.5.5,0,0,1-.5-.5v-5H266.67v5a.5.5,0,0,1-.5.5h-5.08a.5.5,0,0,1-.5-.5V306.19a.5.5,0,0,1,.5-.5H417.15a.5.5,0,0,1,.5.5v98.25A.5.5,0,0,1,417.15,404.94Zm-4.58-1h4.08V306.69H261.59v97.25h4.08v-5a.5.5,0,0,1,.5-.5h145.9a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-46--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "261.09 306.19 261.09 404.44 266.17 404.44 266.17 398.94 412.07 398.94 412.07 404.44 417.15 404.44 417.15 306.19 261.09 306.19",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.67,390.54h-70.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h70.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,336.67,390.54Zm-70-1h69.5V354.79h-69.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-47--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.67,349.71h-70.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h70.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,336.67,349.71Zm-70-1h69.5V315.58h-69.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-48--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.17,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,390.54h-70.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h70.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,412.07,390.54Zm-70-1h69.5V354.79h-69.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-49--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 354.29,
    width: 70.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,349.71h-70.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h70.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,412.07,349.71Zm-70-1h69.5V315.58h-69.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-50--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 315.08,
    width: 70.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 286.17,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.67,390.54h-50.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h50.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,336.67,390.54Zm-50-1h49.5V354.79h-49.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-51--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.17,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 286.17,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.67,349.71h-50.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h50.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,336.67,349.71Zm-50-1h49.5V315.58h-49.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-52--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.17,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.57,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,390.54h-50.5a.5.5,0,0,1-.5-.5V354.29a.5.5,0,0,1,.5-.5h50.5a.5.5,0,0,1,.5.5V390A.5.5,0,0,1,412.07,390.54Zm-50-1h49.5V354.79h-49.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-53--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.57,
    y: 354.29,
    width: 50.49,
    height: 35.75,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.57,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,349.71h-50.5a.5.5,0,0,1-.5-.5V315.08a.51.51,0,0,1,.5-.5h50.5a.51.51,0,0,1,.5.5v34.13A.5.5,0,0,1,412.07,349.71Zm-50-1h49.5V315.58h-49.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-54--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.57,
    y: 315.08,
    width: 50.49,
    height: 34.13,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.42,423.55l-25.12-3V312.66H172V420.57l-25.12,3a4.47,4.47,0,0,0-3.94,4.44,1.6,1.6,0,0,0,1.65,1.6l32.07-.95,32.07.95a1.6,1.6,0,0,0,1.65-1.6A4.47,4.47,0,0,0,206.42,423.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52,430.1a2.07,2.07,0,0,1-1.46-.6,2.1,2.1,0,0,1-.64-1.51,5,5,0,0,1,4.38-4.93l24.68-2.93V312.66a.5.5,0,0,1,.5-.5h9.32a.5.5,0,0,1,.5.5V420.13l24.68,2.93a5,5,0,0,1,4.38,4.93,2.06,2.06,0,0,1-.64,1.51,2.14,2.14,0,0,1-1.53.59l-32.06-.95-32,.95Zm28-116.94V420.57a.51.51,0,0,1-.44.5l-25.12,3a4,4,0,0,0-3.5,3.94,1.11,1.11,0,0,0,.33.79,1.08,1.08,0,0,0,.81.31l32.07-.95,32.09.95a1,1,0,0,0,.81-.31,1.11,1.11,0,0,0,.33-.79,4,4,0,0,0-3.5-3.94l-25.12-3a.51.51,0,0,1-.44-.5V313.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.64,410.26H320.22a0,0,0,0,1,0,0v5.63a0,0,0,0,1,0,0H178.64a2.45,2.45,0,0,1-2.45-2.45v-.72A2.45,2.45,0,0,1,178.64,410.26Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.22,416.38H178.64a3,3,0,0,1-2.95-2.95v-.72a3,3,0,0,1,2.95-2.95H320.22a.5.5,0,0,1,.5.5v5.62A.5.5,0,0,1,320.22,416.38Zm-141.58-5.62a2,2,0,0,0-1.95,1.95v.72a2,2,0,0,0,1.95,1.95H319.72v-4.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.36,423.55l-25.12-3V312.66h-9.32V420.57l-25.12,3a4.47,4.47,0,0,0-3.94,4.44,1.6,1.6,0,0,0,1.65,1.6l32.07-.95,32.07.95a1.6,1.6,0,0,0,1.65-1.6A4.47,4.47,0,0,0,348.36,423.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,430.1h-.07l-32.06-.95-32,.95a2.1,2.1,0,0,1-1.53-.59,2.06,2.06,0,0,1-.64-1.51,5,5,0,0,1,4.38-4.93l24.68-2.93V312.66a.5.5,0,0,1,.5-.5h9.32a.5.5,0,0,1,.5.5V420.13l24.68,2.93A5,5,0,0,1,352.8,428a2.12,2.12,0,0,1-2.1,2.11Zm-32.13-2,32.09.95a1,1,0,0,0,.81-.31,1.11,1.11,0,0,0,.33-.79,4,4,0,0,0-3.5-3.94l-25.12-3a.51.51,0,0,1-.44-.5V313.16h-8.32V420.57a.51.51,0,0,1-.44.5l-25.13,3a4,4,0,0,0-3.49,3.94,1.11,1.11,0,0,0,.33.79,1,1,0,0,0,.81.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.06 312.14 182.3 267.4 166.53 312.14 169.04 313.03 182.3 275.4 195.56 313.03 198.06 312.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.56,313.53a.54.54,0,0,1-.22,0,.48.48,0,0,1-.25-.29L182.3,276.91l-12.79,36.28a.48.48,0,0,1-.25.29.53.53,0,0,1-.39,0l-2.5-.89a.51.51,0,0,1-.31-.64l15.77-44.73a.52.52,0,0,1,.94,0L198.54,312a.51.51,0,0,1-.31.64l-2.51.89A.45.45,0,0,1,195.56,313.53ZM182.3,274.9a.51.51,0,0,1,.47.34l13.09,37.15,1.57-.56L182.3,268.91l-15.13,42.92,1.57.56,13.09-37.15A.51.51,0,0,1,182.3,274.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.97 312.14 324.21 267.4 308.44 312.14 310.95 313.03 324.21 275.4 337.46 313.03 339.97 312.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.46,313.53a.54.54,0,0,1-.21,0,.53.53,0,0,1-.26-.29l-12.78-36.28-12.79,36.28a.5.5,0,0,1-.64.31l-2.5-.89A.51.51,0,0,1,308,312l15.76-44.73a.53.53,0,0,1,.95,0L340.44,312a.5.5,0,0,1-.3.64l-2.51.89A.47.47,0,0,1,337.46,313.53Zm-28.38-1.7,1.56.56,13.09-37.15a.53.53,0,0,1,.95,0l13.09,37.15,1.56-.56-15.12-42.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.56,295.56l29.76-84.43a6.81,6.81,0,0,1,6.43-4.55H335.36a6.82,6.82,0,0,1,6.43,9.09L312,300.1a6.82,6.82,0,0,1-6.44,4.55H171A6.82,6.82,0,0,1,164.56,295.56Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6,305.15H171a7.32,7.32,0,0,1-6.91-9.76h0L193.84,211a7.34,7.34,0,0,1,6.91-4.88H335.36a7.32,7.32,0,0,1,6.9,9.75l-29.75,84.43A7.32,7.32,0,0,1,305.6,305.15ZM165,295.73a6.32,6.32,0,0,0,6,8.42H305.6a6.33,6.33,0,0,0,6-4.22l29.75-84.43a6.32,6.32,0,0,0-6-8.42H200.75a6.32,6.32,0,0,0-6,4.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.56,294.56l29.76-84.43a6.81,6.81,0,0,1,6.43-4.55H333.36a6.82,6.82,0,0,1,6.43,9.09L310,299.1a6.82,6.82,0,0,1-6.44,4.55H169A6.82,6.82,0,0,1,162.56,294.56Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,304.15H169a7.32,7.32,0,0,1-6.91-9.76h0L191.84,210a7.34,7.34,0,0,1,6.91-4.88H333.36a7.32,7.32,0,0,1,6.9,9.75l-29.75,84.43A7.32,7.32,0,0,1,303.6,304.15ZM163,294.73a6.32,6.32,0,0,0,6,8.42H303.6a6.33,6.33,0,0,0,6-4.22l29.75-84.43a6.32,6.32,0,0,0-6-8.42H198.75a6.32,6.32,0,0,0-6,4.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.3 315.61 284.86 315.61 284.86 309.98 352.3 309.98 352.3 312.66 352.3 315.61",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,316.11H284.86a.5.5,0,0,1-.5-.5V310a.5.5,0,0,1,.5-.5H352.3a.5.5,0,0,1,.5.5v5.63A.5.5,0,0,1,352.3,316.11Zm-66.94-1H351.8v-4.63H285.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-55--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.3 315.61 284.86 315.61 284.86 309.98 352.3 309.98 352.3 312.66 352.3 315.61",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 142.92,
    y: 309.98,
    width: 144.04,
    height: 5.63,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,316.11h-144a.5.5,0,0,1-.5-.5V310a.5.5,0,0,1,.5-.5H287a.5.5,0,0,1,.5.5v5.63A.5.5,0,0,1,287,316.11Zm-143.53-1h143v-4.63h-143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,274.9c2.9,0,5.25-3.35,5.25-7.5s-2.35-7.5-5.25-7.5h-3.25c-2.9,0-5.25,3.36-5.25,7.5s2.35,7.5,5.25,7.5Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,275.4h-3.25c-3.17,0-5.75-3.59-5.75-8s2.58-8,5.75-8h3.25c3.17,0,5.75,3.59,5.75,8S332.63,275.4,329.46,275.4Zm-3.25-15c-2.62,0-4.75,3.14-4.75,7s2.13,7,4.75,7h3.25c2.62,0,4.75-3.14,4.75-7s-2.13-7-4.75-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,275.4c-3.17,0-5.75-3.59-5.75-8s2.58-8,5.75-8,5.75,3.59,5.75,8S332.63,275.4,329.46,275.4Zm0-15c-2.62,0-4.75,3.14-4.75,7s2.13,7,4.75,7,4.75-3.14,4.75-7S332.08,260.4,329.46,260.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-56--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.46,
    cy: 267.4,
    rx: 5.25,
    ry: 7.5,
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "228.77 295.35 248.69 238.83 285.96 238.83 283.7 245.25 266.04 295.35 228.77 295.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,295.85H228.77a.52.52,0,0,1-.41-.21.51.51,0,0,1-.06-.45l19.92-56.53a.5.5,0,0,1,.47-.33H286a.51.51,0,0,1,.41.21.5.5,0,0,1,.06.46l-19.92,56.52A.5.5,0,0,1,266,295.85Zm-36.56-1h36.21l19.56-55.52H249Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.73,400.55l-5.06,10.12s-5.13.41-7.88,1.58,5.38,25.23,9.38,25.23,18.62,0,17.87-4.27-10.27-4.16-10.27-4.16l-2.28-8.16a2.45,2.45,0,0,1,2.83,0c1.47,1,1.47-2.22-2.15-2.84l6.75-11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,438h0c-3.7,0-8.79-14.23-10.07-20.49-.93-4.55-.21-5.43.41-5.7a31.33,31.33,0,0,1,7.75-1.59l4.94-9.88a.51.51,0,0,1,.33-.26.5.5,0,0,1,.41.08l9.18,6.5a.49.49,0,0,1,.14.67L202,417.72a3.61,3.61,0,0,1,2.74,2.48,1.14,1.14,0,0,1-.38,1.25,1.09,1.09,0,0,1-1.29-.15,1.9,1.9,0,0,0-1.95-.17l2.07,7.42c1.87,0,9.65.39,10.38,4.58A2.17,2.17,0,0,1,213,435C210.76,437.66,201.8,438,195.26,438Zm3.65-36.69-4.8,9.61a.5.5,0,0,1-.4.27c-.06,0-5.08.41-7.72,1.54,0,0-.67.48.17,4.58,1.62,7.95,6.65,19.69,9,19.69h0c9.89,0,15.61-.89,17.08-2.65a1.21,1.21,0,0,0,.3-1c-.56-3.17-7.24-3.8-9.77-3.75h0a.5.5,0,0,1-.48-.37L200,421a.53.53,0,0,1,.18-.54,3,3,0,0,1,3.42,0l.13.08a1,1,0,0,0-.14-.49,3.25,3.25,0,0,0-2.52-1.53.5.5,0,0,1-.37-.29.47.47,0,0,1,0-.46l6.5-10.6Zm-5.24,9.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.17,437.48c4,0,18.62,0,17.87-4.27s-10.27-4.16-10.27-4.16l-2.28-8.16a2.45,2.45,0,0,1,2.83,0c1.47,1,1.47-2.22-2.15-2.84,0,0-3.75,1-5.25-.95l-1.38-2.55s1.26-1.88-.87-3.88c0,0-5.13.41-7.88,1.58S191.17,437.48,195.17,437.48Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,438h0l-.08-.5v.5c-3.62,0-8.71-14.23-10-20.49-.93-4.55-.21-5.43.41-5.7,2.8-1.19,7.82-1.6,8-1.62a.52.52,0,0,1,.38.14,3.56,3.56,0,0,1,1.1,4.24l1.25,2.31c1.23,1.57,4.65.71,4.68.7a.74.74,0,0,1,.21,0c2.22.39,3.25,1.67,3.45,2.65a1.14,1.14,0,0,1-.38,1.25,1.09,1.09,0,0,1-1.29-.15,1.9,1.9,0,0,0-1.95-.17l2.07,7.42c1.87,0,9.65.39,10.38,4.58A2.17,2.17,0,0,1,213,435C210.76,437.66,201.8,438,195.26,438Zm-1.78-26.79a31.3,31.3,0,0,0-7.49,1.52s-.67.48.17,4.58c1.62,7.95,6.65,19.69,9,19.69h.09c9.8,0,15.52-.89,17-2.65a1.21,1.21,0,0,0,.3-1c-.56-3.17-7.24-3.8-9.77-3.75h0a.5.5,0,0,1-.48-.37L200,421a.53.53,0,0,1,.18-.54,3,3,0,0,1,3.42,0l.13.08a1,1,0,0,0-.14-.49,3.21,3.21,0,0,0-2.42-1.51c-.67.16-4.11.83-5.66-1.15l-1.42-2.62a.49.49,0,0,1,0-.52A2.46,2.46,0,0,0,193.48,411.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57,411.83a4.62,4.62,0,0,0-.9-1.16s-5.13.41-7.88,1.58c0,0,.3.55.79,1.49A47.43,47.43,0,0,1,194.57,411.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58,414.24a.5.5,0,0,1-.44-.27c-.49-.93-.79-1.48-.79-1.48a.47.47,0,0,1,0-.4.47.47,0,0,1,.27-.3c2.8-1.19,7.82-1.6,8-1.62a.52.52,0,0,1,.38.14,4.78,4.78,0,0,1,1,1.29.48.48,0,0,1,0,.45.47.47,0,0,1-.36.27,47.42,47.42,0,0,0-7.91,1.89A.45.45,0,0,1,186.58,414.24Zm-.08-1.73.32.62a47.84,47.84,0,0,1,6.9-1.67,2.91,2.91,0,0,0-.24-.27A34.13,34.13,0,0,0,186.5,412.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.97,
    cy: 419.01,
    r: 1.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,421a2,2,0,1,1,2-2A2,2,0,0,1,193,421Zm0-3.05a1,1,0,1,0,1,1A1,1,0,0,0,193,418Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.92,434.63a.5.5,0,0,1-.47-.33c-1-2.59-2-3.34-2-3.34a.51.51,0,0,1-.11-.7.5.5,0,0,1,.69-.12c.12.08,1.26.93,2.32,3.82a.5.5,0,0,1-.29.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.92,320.63h36.75s49.08,21.94,47.17,31.57-35.2,59.05-35.2,59.05l-10.94-7.91s15.72-36.79,24-47c0,0-9-1.83-25.25-7.54h-29C161.58,348.76,152.17,347.46,158.92,320.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.64,411.75a.5.5,0,0,1-.29-.09l-10.94-7.92a.5.5,0,0,1-.17-.6c.63-1.47,15.24-35.58,23.54-46.52a236.2,236.2,0,0,1-24.44-7.36H166.4c-2.47,0-5.6-.36-7.81-3.2-3.3-4.24-3.36-12.84-.16-25.55a.51.51,0,0,1,.49-.38h36.75a.45.45,0,0,1,.2,0c2,.91,49.43,22.22,47.46,32.13-1.92,9.62-33.91,57.21-35.27,59.23a.52.52,0,0,1-.33.21Zm-10.32-8.58,10.2,7.37c3.26-4.87,33-49.48,34.83-58.44,1.5-7.56-33.17-24.88-46.79-31H159.31c-3,12.19-3,20.37.07,24.32,1.94,2.49,4.77,2.81,7,2.81h29a.51.51,0,0,1,.17,0c16,5.63,25.09,7.5,25.18,7.52a.48.48,0,0,1,.37.32.54.54,0,0,1-.08.48C213.38,366.15,199,399.3,197.32,403.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-57--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.92,320.63h36.75s49.08,21.94,47.17,31.57-35.2,59.05-35.2,59.05l-10.94-7.91s15.72-36.79,24-47c0,0-9-1.83-25.25-7.54h-29C161.58,348.76,152.17,347.46,158.92,320.63Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.09,399.05l11.43,8.34a1.17,1.17,0,0,1,.18,1.74l-1.06,1.16-1.23,2.09a1.18,1.18,0,0,1-1.69.36L195,404.48a1.18,1.18,0,0,1-.11-1.83l2.14-1.95.17-.91A1.17,1.17,0,0,1,199.09,399.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.4,413.45a1.66,1.66,0,0,1-1-.3l-11.68-8.26a1.63,1.63,0,0,1-.7-1.27,1.68,1.68,0,0,1,.54-1.34l2-1.83.13-.75a1.68,1.68,0,0,1,2.64-1.06h0L210.82,407a1.67,1.67,0,0,1,.25,2.48l-1,1.12-1.21,2a1.72,1.72,0,0,1-1.09.79Zm-9-14.13a.6.6,0,0,0-.26.05.65.65,0,0,0-.41.51l-.16.91a.5.5,0,0,1-.16.28L195.26,403a.7.7,0,0,0-.22.54.71.71,0,0,0,.29.52L207,412.33a.69.69,0,0,0,.54.11.68.68,0,0,0,.44-.32l1.23-2.09.06-.08,1.06-1.15a.68.68,0,0,0,.17-.53.71.71,0,0,0-.27-.48l-11.44-8.34A.63.63,0,0,0,198.4,399.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-58--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.09,399.05l11.43,8.34a1.17,1.17,0,0,1,.18,1.74l-1.06,1.16-1.23,2.09a1.18,1.18,0,0,1-1.69.36L195,404.48a1.18,1.18,0,0,1-.11-1.83l2.14-1.95.17-.91A1.17,1.17,0,0,1,199.09,399.05Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.92,409.49a.52.52,0,0,1-.38-.17,30.33,30.33,0,0,0-6.07-5.08.5.5,0,1,1,.55-.84,31.78,31.78,0,0,1,6.27,5.25.51.51,0,0,1-.37.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,403.49a.43.43,0,0,1-.25-.07c-1-.56-1.61-.85-1.62-.85a.52.52,0,0,1-.25-.67.5.5,0,0,1,.67-.24s.67.31,1.7.9a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.17,437.48c4,0,18.62,0,17.87-4.27-5.37,3.67-17,1.71-17,1.71-2.37-8.12-10.25-22.67-10.25-22.67C183,413.42,191.17,437.48,195.17,437.48Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,438h0l-.08-.5v.5c-3.62,0-8.71-14.23-10-20.49-.93-4.55-.21-5.43.41-5.7a.51.51,0,0,1,.64.22c.08.15,7.73,14.33,10.2,22.47,1.85.27,11.66,1.51,16.33-1.68a.52.52,0,0,1,.47-.05.51.51,0,0,1,.3.38A2.17,2.17,0,0,1,213,435C210.76,437.66,201.8,438,195.26,438Zm-9.48-24.69a12.47,12.47,0,0,0,.38,4c1.62,7.95,6.65,19.69,9,19.69h.09c9.8,0,15.52-.89,17-2.65l.1-.12c-5.75,3-15.94,1.28-16.39,1.21a.51.51,0,0,1-.4-.36C193.54,428.17,187.45,416.44,185.78,413.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.19,358.55a.5.5,0,0,1-.3-.9c.87-.64,1-1,1-1.08-.19-.63-3.53-.84-5-.93-2.24-.15-3.16-.21-3.26-.89s.58-.88,1.34-1.17a22.43,22.43,0,0,1,3.42-1,.5.5,0,1,1,.21,1,24.78,24.78,0,0,0-3.28,1h0c.48.05,1.09.09,1.63.12,3.2.2,5.49.44,5.85,1.65.25.87-.64,1.65-1.33,2.16A.49.49,0,0,1,230.19,358.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,238.07l-.47-5.69,7.66-1.81-1.38-8.72,2.45-1.6a1.42,1.42,0,0,0,.19-2.23l-4.28-4-1.67-7.7s-4.47-14.17-20.84-3.54,4.57,27.56,4.57,27.56l-.52,7.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,238.57H169.72a.52.52,0,0,1-.37-.16.51.51,0,0,1-.13-.37l.51-7.45c-1.58-1.33-11.26-9.8-10.8-18.44.2-3.83,2.37-7.12,6.46-9.77,5.75-3.73,10.72-4.88,14.77-3.43,5.06,1.82,6.75,7,6.82,7.24l1.65,7.59,4.17,3.88a1.88,1.88,0,0,1,.61,1.56,2,2,0,0,1-.86,1.45l-2.19,1.42,1.34,8.41a.51.51,0,0,1-.38.56l-7.25,1.71.44,5.26a.5.5,0,0,1-.5.54Zm-13.76-1h13.22l-.43-5.15a.52.52,0,0,1,.39-.53l7.21-1.7-1.32-8.26a.51.51,0,0,1,.22-.5l2.46-1.6a.9.9,0,0,0,.41-.69.88.88,0,0,0-.29-.75l-4.28-4a.46.46,0,0,1-.15-.26L186,206.45s-1.61-4.91-6.21-6.56c-3.74-1.34-8.41-.22-13.87,3.33-3.81,2.47-5.83,5.49-6,9-.45,8.7,10.53,17.69,10.64,17.78a.49.49,0,0,1,.18.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.24,230.36a8.24,8.24,0,0,1,5.72-.48s1.54-4.58.54-7.67a11.42,11.42,0,0,1-.54-5.33l2-.33s-1.25-5.17-1.17-6.63a7.26,7.26,0,0,1,1.14-3.62c2.72-2.81,14.29-5,10.89-11.25-2.66-4.92-4.78,1.83-8.2,1.58s-.77-5.88-4.42-6.83c-4.16-1.09-2.43,3.41-6.49,6.83S151.08,208.71,159,216C159,216,156.14,220.55,170.24,230.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.24,230.86a.47.47,0,0,1-.28-.09c-12.22-8.5-12-13.29-11.55-14.64a6.57,6.57,0,0,1-2.24-5.12c.25-5,6.61-9.79,10.83-12.95.93-.7,1.75-1.31,2.34-1.81a9.78,9.78,0,0,0,2.83-4.32c.69-1.72,1.33-3.34,4.11-2.62,2.17.57,2.45,2.55,2.68,4.14s.43,2.59,1.66,2.68,2.22-.85,3.24-1.75,2-1.81,3.19-1.6c.8.14,1.51.8,2.17,2a4.56,4.56,0,0,1,.49,3.65c-.85,2.63-4.31,4.31-7.36,5.78a16.75,16.75,0,0,0-4.11,2.41,7,7,0,0,0-1,3.3,42.07,42.07,0,0,0,1.15,6.48.48.48,0,0,1-.07.39.45.45,0,0,1-.33.22l-1.59.27a11.73,11.73,0,0,0,.56,4.75c1,3.2-.47,7.79-.53,8a.5.5,0,0,1-.59.33,7.87,7.87,0,0,0-5.36.43A.51.51,0,0,1,170.24,230.86ZM175,190.13c-1.06,0-1.36.75-1.93,2.17A10.71,10.71,0,0,1,170,197c-.62.53-1.44,1.14-2.39,1.85-4.07,3-10.2,7.66-10.43,12.2a5.69,5.69,0,0,0,2.17,4.58.5.5,0,0,1,.08.63s-2.24,4.32,10.87,13.51a8.94,8.94,0,0,1,5.33-.49c.34-1.18,1.17-4.56.4-6.92a11.82,11.82,0,0,1-.55-5.59.51.51,0,0,1,.41-.39l1.43-.25a36.7,36.7,0,0,1-1.06-6.24c.05-1,.48-3.13,1.28-4a16.76,16.76,0,0,1,4.38-2.61c2.87-1.39,6.13-3,6.84-5.18a3.55,3.55,0,0,0-.41-2.87c-.5-.93-1-1.44-1.47-1.53-.67-.12-1.49.61-2.35,1.37-1.12,1-2.39,2.12-4,2-2.1-.15-2.35-1.95-2.58-3.54-.26-1.81-.52-2.94-1.94-3.31A4.11,4.11,0,0,0,175,190.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,215.13s-5.33,5.91-8.08-.51S155.72,216.46,161,215.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,218.11a3,3,0,0,1-.59-.05c-1.42-.23-2.56-1.32-3.38-3.24s-1-2.63-.51-3,1.12,0,2.27.73c1.69,1.08,4.24,2.72,6.66,2.1a.51.51,0,0,1,.55.23.5.5,0,0,1-.06.59C161.24,215.58,158.92,218.11,156.4,218.11Zm-3.67-5.29a15.08,15.08,0,0,0,.62,1.61c.67,1.58,1.56,2.47,2.63,2.65a5,5,0,0,0,3.54-1.31c-2.29-.09-4.47-1.49-5.87-2.39C153.35,213.19,153,213,152.73,212.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48,212a.32.32,0,0,1-.16,0,.37.37,0,0,1-.17-.5c.09-.19,2.36-4.59,13.89-8.51a31.72,31.72,0,0,0,6.81-3.06.37.37,0,0,1,.52.12.38.38,0,0,1-.11.52,32.86,32.86,0,0,1-7,3.13c-11.17,3.8-13.44,8.09-13.46,8.13A.39.39,0,0,1,162.48,212Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.37,198.58a.35.35,0,0,1-.22-.08.37.37,0,0,1-.08-.52c.83-1.09.55-1.74.54-1.77a.37.37,0,0,1,.17-.49.36.36,0,0,1,.5.16s.53,1.06-.61,2.55A.36.36,0,0,1,185.37,198.58Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59,209.37a.29.29,0,0,1-.16,0,.37.37,0,0,1-.18-.5,10.58,10.58,0,0,1,.6-1.07.38.38,0,0,1,.64.4,7.8,7.8,0,0,0-.56,1A.39.39,0,0,1,160.59,209.37Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48,206.64a.35.35,0,0,1-.25-.1.38.38,0,0,1,0-.53c3-3.36,8-6.14,10.66-7.5a4.27,4.27,0,0,0,2.4-2.59,4.91,4.91,0,0,0-.62-3.5.38.38,0,0,1,.63-.41,5.55,5.55,0,0,1,.71,4.1,4.93,4.93,0,0,1-2.78,3.07c-2.64,1.34-7.5,4.06-10.44,7.34A.38.38,0,0,1,162.48,206.64Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.29,218.08s-4.52-2.2-4.28,1.77c.28,4.73,5.27,5.84,5.91,3.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.15,225l-.35,0a5.17,5.17,0,0,1-4.29-5.14,2.62,2.62,0,0,1,1-2.52c1.43-1,3.79.14,4,.27a.5.5,0,1,1-.44.9c-.57-.28-2.25-.88-3-.34-.39.26-.56.8-.51,1.63a4.16,4.16,0,0,0,3.39,4.2c.3,0,1.3.07,1.53-.79a.5.5,0,0,1,1,.26A2.18,2.18,0,0,1,176.15,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.15,213.36c.31.77.28,1.51-.06,1.65s-.88-.37-1.19-1.14-.28-1.51.06-1.65S185.84,212.59,186.15,213.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,213.62h-1a4.57,4.57,0,0,1,2.28-4.14l.45.89-.23-.45.23.45A3.59,3.59,0,0,0,183,213.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.22,225.4a4.72,4.72,0,0,1-3-1,.5.5,0,0,1,.62-.79c1.73,1.37,4.3.43,4.33.42a.5.5,0,0,1,.64.29.49.49,0,0,1-.29.64A6.9,6.9,0,0,1,186.22,225.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,323.77s44.89,6.8,51.9,18,7.08,71.86,7.08,71.86l-12.33,1.5s-10-44-9.48-60.62a247.71,247.71,0,0,0-36.17-5.5c-18-1.17-36,3.43-34.67-25.28v-3.14h33.49Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15,415.67a.5.5,0,0,1-.49-.39c-.1-.43-9.83-43.5-9.5-60.34a249.28,249.28,0,0,0-35.69-5.39c-2.63-.17-5.27-.22-7.82-.27-8.93-.16-17.36-.31-22.44-5.73-3.72-4-5.31-10.44-4.88-19.81v-3.11a.5.5,0,0,1,.5-.5h33.49a.5.5,0,0,1,.5.47l.15,2.73c4.78.75,45.07,7.35,51.85,18.21,7,11.24,7.16,69.65,7.16,72.13a.5.5,0,0,1-.44.5l-12.33,1.5Zm-79.82-94.54v2.64c-.42,9.1,1.09,15.34,4.61,19.1,4.79,5.11,13,5.26,21.73,5.41,2.56.05,5.22.1,7.86.27a252.47,252.47,0,0,1,36.25,5.51.52.52,0,0,1,.39.5c-.47,15.53,8.33,55.42,9.37,60.06L262,413.23c0-5.53-.46-60.67-7-71.16-6.82-10.91-51.11-17.74-51.56-17.81a.49.49,0,0,1-.42-.47l-.15-2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.72,406.05a.5.5,0,0,1-.5-.48l-.15-2.74a.5.5,0,0,1,.48-.52.48.48,0,0,1,.52.47l.15,2.74a.51.51,0,0,1-.48.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.35,399.32a.51.51,0,0,1-.5-.47c-1-16.85-3.14-46.18-6.64-53.42-.68-1.41-4.23-3.95-17.29-8.05a.51.51,0,0,1-.33-.63.49.49,0,0,1,.63-.32c10.91,3.42,16.76,6.22,17.9,8.57,3.56,7.39,5.75,36.87,6.73,53.79a.5.5,0,0,1-.47.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.24,336l-.14,0c-10.17-3-20.11-5.21-20.21-5.23a.5.5,0,0,1-.36-.3c-1.71-4.37-9.19-6.13-9.26-6.15a.5.5,0,0,1-.38-.59.51.51,0,0,1,.6-.38c.32.07,7.8,1.83,9.87,6.5,1.62.37,10.72,2.48,20,5.18a.51.51,0,0,1,.34.62A.52.52,0,0,1,229.24,336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.79,327.08h-.07c-2.4-.32-6-.84-9.65-1.54a.5.5,0,1,1,.19-1c3.6.69,7.2,1.21,9.59,1.52a.5.5,0,0,1-.06,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.91,415.08l1.51,9.59s-.63,7.88,1.62,9.19,13.77-2.55,18.06-4.31c3.82-1.57,14.57-6.84,13.07-10.13s-11.19.94-11.19.94l-8.62-.1s1.24-3.52-.38-3.52-.94,2.25-3,2.62l-.32-5.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,434.62a3.5,3.5,0,0,1-1.72-.33c-2.4-1.4-2-8.52-1.88-9.6l-1.5-9.53a.51.51,0,0,1,.1-.38.5.5,0,0,1,.34-.2l10.75-1.3a.44.44,0,0,1,.38.11.5.5,0,0,1,.18.35l.28,4.93a2.11,2.11,0,0,0,.78-1c.29-.62.66-1.39,1.76-1.39a1.18,1.18,0,0,1,1,.5c.53.75.27,2.17,0,3l7.84.09c1.41-.59,10.18-4.05,11.74-.64a2.26,2.26,0,0,1,0,1.82c-1.63,4.12-13.2,8.92-13.32,9C270.15,430.89,260.06,434.62,255.51,434.62Zm-4-19.11,1.43,9.09a.2.2,0,0,1,0,.11c-.23,2.93-.06,7.88,1.38,8.72,1.89,1.1,12.63-2.29,17.62-4.34,4.36-1.8,11.68-5.67,12.77-8.41a1.29,1.29,0,0,0,0-1.05c-.9-2-6.94-.32-10.54,1.19a.45.45,0,0,1-.2,0l-8.61-.1a.5.5,0,0,1-.47-.66c.31-.86.61-2.34.3-2.78,0,0-.06-.08-.21-.08-.43,0-.56.2-.85.81a2.69,2.69,0,0,1-2.06,1.8.47.47,0,0,1-.4-.1.52.52,0,0,1-.19-.36l-.29-5.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29,423.71a5.23,5.23,0,0,0-5.87,1s-.63,7.88,1.62,9.19,13.77-2.55,18.06-4.31c3.82-1.57,14.57-6.84,13.07-10.13s-11.19.94-11.19.94l-8.62-.1s1.24-3.52-.38-3.52-.94,2.25-3,2.62C260.43,423.39,258.29,423.71,258.29,423.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,434.62a3.5,3.5,0,0,1-1.72-.33c-2.45-1.43-1.94-8.82-1.87-9.66a.47.47,0,0,1,.12-.29,5.68,5.68,0,0,1,6.28-1.15c.42-.14,2-.86,3.19-4a.5.5,0,0,1,.38-.31c.82-.15,1.05-.66,1.33-1.24s.66-1.39,1.76-1.39a1.18,1.18,0,0,1,1,.5c.53.75.27,2.17,0,3l7.84.09c1.41-.59,10.18-4.05,11.74-.64a2.26,2.26,0,0,1,0,1.82c-1.63,4.12-13.2,8.92-13.32,9C270.15,430.89,260.06,434.62,255.51,434.62Zm-2.61-9.73c-.21,2.95,0,7.72,1.39,8.54,1.89,1.1,12.63-2.29,17.62-4.34,4.36-1.8,11.68-5.67,12.77-8.41a1.29,1.29,0,0,0,0-1.05c-.9-2-6.94-.32-10.54,1.19a.45.45,0,0,1-.2,0l-8.61-.1a.5.5,0,0,1-.47-.66c.31-.86.61-2.34.3-2.78,0,0-.06-.08-.21-.08-.43,0-.56.2-.85.81a2.76,2.76,0,0,1-1.78,1.74c-1.63,4-3.89,4.4-4,4.42a.57.57,0,0,1-.26,0A4.8,4.8,0,0,0,252.9,424.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29,423.71a5.23,5.23,0,0,0-5.87,1s-.63,7.88,1.62,9.19,13.77-2.55,18.06-4.31c3.82-1.57,14.57-6.84,13.07-10.13s-11.19.94-11.19.94l-8.62-.1s1.24-3.52-.38-3.52-.94,2.25-3,2.62C260.43,423.39,258.29,423.71,258.29,423.71Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,434.62a3.5,3.5,0,0,1-1.72-.33c-2.45-1.43-1.94-8.82-1.87-9.66a.47.47,0,0,1,.12-.29,5.68,5.68,0,0,1,6.28-1.15c.42-.14,2-.86,3.19-4a.5.5,0,0,1,.38-.31c.82-.15,1.05-.66,1.33-1.24s.66-1.39,1.76-1.39a1.18,1.18,0,0,1,1,.5c.53.75.27,2.17,0,3l7.84.09c1.41-.59,10.18-4.05,11.74-.64a2.26,2.26,0,0,1,0,1.82c-1.63,4.12-13.2,8.92-13.32,9C270.15,430.89,260.06,434.62,255.51,434.62Zm-2.61-9.73c-.21,2.95,0,7.72,1.39,8.54,1.89,1.1,12.63-2.29,17.62-4.34,4.36-1.8,11.68-5.67,12.77-8.41a1.29,1.29,0,0,0,0-1.05c-.9-2-6.94-.32-10.54,1.19a.45.45,0,0,1-.2,0l-8.61-.1a.5.5,0,0,1-.47-.66c.31-.86.61-2.34.3-2.78,0,0-.06-.08-.21-.08-.43,0-.56.2-.85.81a2.76,2.76,0,0,1-1.78,1.74c-1.63,4-3.89,4.4-4,4.42a.57.57,0,0,1-.26,0A4.8,4.8,0,0,0,252.9,424.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.21,419.56c-1.76,2.05-4.91,4.52-10.54,7-10.89,4.72-19,5.3-21.83,5.34a3.27,3.27,0,0,0,1.2,2c2.25,1.31,13.77-2.55,18.06-4.31C275.87,428,286.37,422.85,285.21,419.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,434.62a3.5,3.5,0,0,1-1.72-.33,3.56,3.56,0,0,1-1.43-2.28.47.47,0,0,1,.08-.44.5.5,0,0,1,.39-.2c2.93,0,10.91-.65,21.64-5.3,4.76-2.07,8.24-4.37,10.36-6.84a.5.5,0,0,1,.47-.17.51.51,0,0,1,.38.33c1.56,4.41-13.24,10.56-13.39,10.62C270.15,430.89,260.06,434.62,255.51,434.62Zm-2-2.27a2.1,2.1,0,0,0,.76,1.08c1.89,1.1,12.63-2.29,17.62-4.34,4.81-2,11.27-5.57,12.63-8.1a32.65,32.65,0,0,1-9.68,6C264.72,431.39,257,432.23,253.53,432.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.57,431.61a24.27,24.27,0,0,1-.77-8.36,5,5,0,0,0-2.28.61,39.53,39.53,0,0,0,.56,8C254.77,431.79,255.61,431.72,256.57,431.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.08,432.33a.5.5,0,0,1-.49-.41,40.08,40.08,0,0,1-.57-8.07.48.48,0,0,1,.26-.43,5.47,5.47,0,0,1,2.51-.67.51.51,0,0,1,.38.16.5.5,0,0,1,.13.4,23.37,23.37,0,0,0,.76,8.18.5.5,0,0,1-.08.41.53.53,0,0,1-.35.21c-.91.1-1.75.17-2.52.22Zm-.07-8.16a41.69,41.69,0,0,0,.48,7.13c.47,0,1-.07,1.47-.13a25.15,25.15,0,0,1-.72-7.37A4.47,4.47,0,0,0,254,424.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.17,425.35a1.62,1.62,0,0,1-.75,2.09c-.7.2-1.49-.41-1.77-1.36a1.61,1.61,0,0,1,.76-2.09C262.11,423.79,262.9,424.39,263.17,425.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.13,428a2.23,2.23,0,0,1-2-1.76,1.86,1.86,0,1,1,3.48-1h0a2.08,2.08,0,0,1-1.1,2.71A1.47,1.47,0,0,1,262.13,428Zm-.45-3.53-.13,0c-.42.12-.61.81-.42,1.47s.73,1.15,1.15,1,.61-.81.41-1.47h0C262.52,424.89,262.07,424.45,261.68,424.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.39,421a4.87,4.87,0,0,1,3.09,1.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.48,423a.51.51,0,0,1-.39-.19,4.36,4.36,0,0,0-2.77-1.34.5.5,0,1,1,.14-1,5.26,5.26,0,0,1,3.4,1.7.49.49,0,0,1-.06.7A.51.51,0,0,1,279.48,423Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,410.34l14.07-1.53A1.18,1.18,0,0,1,264,410v1.57l.49,2.37a1.17,1.17,0,0,1-1,1.41l-14.18,1.76a1.18,1.18,0,0,1-1.32-1.28l.27-2.89-.49-.78A1.18,1.18,0,0,1,248.67,410.34Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.19,417.6a1.68,1.68,0,0,1-1.67-1.84l.26-2.71-.41-.64a1.68,1.68,0,0,1,1.24-2.56h0l14.07-1.53a1.68,1.68,0,0,1,1.86,1.66v1.52l.48,2.32a1.68,1.68,0,0,1-1.43,2l-14.19,1.76Zm-.47-6.76a.68.68,0,0,0-.5,1l.49.78a.48.48,0,0,1,.08.31l-.27,2.89a.68.68,0,0,0,.2.55.66.66,0,0,0,.55.18l14.19-1.76a.67.67,0,0,0,.47-.27A.69.69,0,0,0,264,414l-.49-2.37a.34.34,0,0,1,0-.1V410a.67.67,0,0,0-.75-.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-59--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.67,410.34l14.07-1.53A1.18,1.18,0,0,1,264,410v1.57l.49,2.37a1.17,1.17,0,0,1-1,1.41l-14.18,1.76a1.18,1.18,0,0,1-1.32-1.28l.27-2.89-.49-.78A1.18,1.18,0,0,1,248.67,410.34Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.15,413.33a.5.5,0,0,1,0-1,73.2,73.2,0,0,0,8.37-1.05.5.5,0,1,1,.18,1,73.54,73.54,0,0,1-8.49,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15,413.45h0a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h0s.54,0,1.48,0a.49.49,0,0,1,.52.48.5.5,0,0,1-.48.52C250.75,413.45,250.21,413.45,250.15,413.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.54,353.4a.7.7,0,0,1-.49-.19c-.41-.4-.21-1.06.33-2.22,2.26-4.86,6-5.57,6.2-5.6a.49.49,0,0,1,.58.4.51.51,0,0,1-.41.58c-.14,0-3.43.68-5.46,5a7.09,7.09,0,0,0-.35.84l.59-.3c1.48-.76,3.95-2,5.53,0a.5.5,0,1,1-.79.61c-1-1.24-2.58-.56-4.28.32A3.74,3.74,0,0,1,242.54,353.4Zm.3-.75h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.35,243.3l1.14-5.2v-1.31a.94.94,0,0,1,.77-1c3.08-.53,14.58-2.2,20.8,1.2a.6.6,0,0,1,.05,1l-1.27.86a.59.59,0,0,0-.24.61l.58,3Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.35,243.8a.53.53,0,0,1-.39-.18.55.55,0,0,1-.1-.43l1.13-5.14v-1.26a1.47,1.47,0,0,1,1.19-1.46c3.36-.57,14.81-2.19,21.12,1.26a1.08,1.08,0,0,1,.57.92,1.09,1.09,0,0,1-.48,1l-1.27.85a.11.11,0,0,0,0,.1l.58,3a.49.49,0,0,1-.1.41.54.54,0,0,1-.37.19l-21.83.75Zm11.86-8.36a60.85,60.85,0,0,0-9.86.88.47.47,0,0,0-.36.47v1.31s0,.07,0,.11l-1,4.57,20.61-.71-.48-2.46a1.1,1.1,0,0,1,.46-1.12l1.27-.85.23-.61-.24.43C184,235.91,180,235.44,176.21,235.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.84,322.71s14.83,1.62,26,.73,22-1.56,22-1.56a237.4,237.4,0,0,1-3-36.17c0-19.16,3.13-40.66-6.7-43.5s-35.56-5.4-42,2.89S156.51,277.88,156.84,322.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.32,324.21c-9.29,0-18.42-1-18.54-1a.5.5,0,0,1-.44-.49,376.88,376.88,0,0,0-4-49.62c-2-14.78-3.18-23.7.42-28.31C159.61,236,186,239,195.3,241.73c8.26,2.38,7.8,17,7.31,32.5-.12,3.78-.24,7.69-.24,11.48a239.11,239.11,0,0,0,2.95,36.08.47.47,0,0,1-.1.4.5.5,0,0,1-.36.19c-.11,0-11,.68-22,1.56C180.47,324.13,177.89,324.21,175.32,324.21Zm-18-1.95c2.55.26,15.54,1.47,25.46.68,9.62-.77,19.11-1.38,21.46-1.52a241.48,241.48,0,0,1-2.88-35.71c0-3.8.12-7.72.24-11.52.48-15.08.93-29.33-6.58-31.49-10.91-3.15-35.45-5-41.5,2.7-3.34,4.28-2.1,13.55-.22,27.57A377.52,377.52,0,0,1,157.33,322.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.72,296.92a5.42,5.42,0,0,1,3,0c2.25.61,5.3,2.08,7.35,1a15.27,15.27,0,0,0,5.63-5.61s3.49-2.78,2.36-4.28c-.59-.78-5.48,3.71-6,2.91s2.76-3.28,4.12-5.29,1.62-4.25,1-4.62-1.63,1.37-1.63,1.37,1.06-2.06.38-2.56-3.09,2.48-3.09,2.48.83-1.58-.1-1.85-2.44,2.44-3.25,3.5.81-2.07.19-2.63-1.25,2.25-2.75,5.38a11.48,11.48,0,0,1-2.83,4.1l-4.37-1.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.32,298.82a14.39,14.39,0,0,1-4.24-.94c-.52-.17-1-.34-1.51-.46a5,5,0,0,0-2.68,0,.48.48,0,0,1-.45-.06.49.49,0,0,1-.22-.41v-7.68a.48.48,0,0,1,.22-.41.47.47,0,0,1,.46-.06l4.08,1.5a12.73,12.73,0,0,0,2.48-3.75c.54-1.12,1-2.21,1.32-3.09.65-1.65,1-2.48,1.56-2.62a.71.71,0,0,1,.66.18,1.1,1.1,0,0,1,.31.92c.84-1.19,1.7-2.16,2.56-1.9a1,1,0,0,1,.7.61l0,.08c1.19-1.22,2.06-1.65,2.61-1.24a1.21,1.21,0,0,1,.43,1.09l.09,0a.86.86,0,0,1,.69.09,1.13,1.13,0,0,1,.51.79,6.82,6.82,0,0,1-1.35,4.54,21.54,21.54,0,0,1-2.25,2.59,16.56,16.56,0,0,0-1.66,1.87,23.64,23.64,0,0,0,2-1.29c1.9-1.29,3.16-2.15,3.74-1.37,1.31,1.74-1.73,4.38-2.37,4.9a15.57,15.57,0,0,1-5.79,5.73A4.09,4.09,0,0,1,225.32,298.82Zm-7.18-2.6a6.48,6.48,0,0,1,1.69.23c.49.13,1,.31,1.56.48,1.88.62,4,1.32,5.43.57a14.91,14.91,0,0,0,5.42-5.41.47.47,0,0,1,.13-.15c1-.77,2.72-2.57,2.34-3.47a14.68,14.68,0,0,0-2.45,1.48c-1.62,1.1-2.56,1.72-3.18,1.59a.72.72,0,0,1-.45-.3c-.52-.81.47-1.84,2-3.4a20.67,20.67,0,0,0,2.14-2.45c1.29-1.91,1.36-3.68,1.14-3.93a6,6,0,0,0-.92,1.21.5.5,0,0,1-.87-.48,4,4,0,0,0,.54-1.86,9.9,9.9,0,0,0-2.42,2.32.5.5,0,0,1-.66.11.49.49,0,0,1-.17-.65,1.92,1.92,0,0,0,.26-1.1c-.46-.09-1.66,1.67-2.1,2.32a11.41,11.41,0,0,1-.68,1c-.14.19-.43.57-.84.36s-.3-.61-.09-1.25c.05-.15.14-.44.22-.73-.15.34-.3.74-.45,1.12-.35.9-.79,2-1.34,3.16-1.54,3.2-2.92,4.25-3,4.29a.5.5,0,0,1-.47.07l-3.7-1.36v6.34A7.37,7.37,0,0,1,218.14,296.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.41,288.86h0a3.64,3.64,0,0,1-.85-.16,2.83,2.83,0,0,0-1.46-.11.5.5,0,0,1-.24-1,3.62,3.62,0,0,1,2,.12,2.94,2.94,0,0,0,.61.12c.53,0,2.41-2.14,4-4.59a.5.5,0,1,1,.83.55C231.27,285.34,228.8,288.86,227.41,288.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.76,287.38a.48.48,0,0,1-.41-.21.5.5,0,0,1,.12-.7,9.51,9.51,0,0,0,2.38-3.15.5.5,0,0,1,.88.46,10.08,10.08,0,0,1-2.69,3.51A.47.47,0,0,1,226.76,287.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.17,246.55c2.63-2,8.31-5.34,12.84,1.69,6.58,10.24,19,26.81,20.14,31.31,0,0,9,.87,15.35,3.68a103.26,103.26,0,0,0,15.72,5.85s2.26,5.8-1.5,8.86c0,0-34-1.46-38.18-4.57S159,265.9,155.25,258.75C152.09,252.75,151.29,249.49,155.17,246.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.72,298.44h0c-1.39-.06-34.17-1.51-38.46-4.67S158.68,266.33,154.81,259c-3.26-6.2-4.09-9.7.05-12.84,2.8-2.12,5.43-3,7.81-2.56,2.2.38,4.13,1.86,5.76,4.38,2.17,3.38,5,7.55,7.82,11.57,5.74,8.34,11.18,16.23,12.28,19.54,1.72.19,9.45,1.15,15.17,3.69a102.78,102.78,0,0,0,15.63,5.82.53.53,0,0,1,.36.31c.09.25,2.35,6.18-1.65,9.43A.52.52,0,0,1,217.72,298.44Zm-56.24-54a10.24,10.24,0,0,0-6,2.47h0c-3.61,2.74-2.89,5.65.23,11.57,3.74,7.1,20,31.4,24.14,34.45,3.21,2.37,25.95,3.95,37.71,4.46,2.84-2.48,1.64-6.85,1.29-7.93a107,107,0,0,1-15.55-5.81c-6.18-2.75-15.1-3.64-15.19-3.64a.49.49,0,0,1-.43-.38c-.77-2.92-6.61-11.38-12.25-19.56-2.78-4-5.65-8.2-7.84-11.6-1.46-2.28-3.17-3.6-5.08-3.94A5.86,5.86,0,0,0,161.48,244.48Zm-6.31,2.07h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.78,299.59a.36.36,0,0,1-.24-.09c-.52-.44-1-.86-1.57-1.26a.38.38,0,0,1,.45-.6c.55.41,1.08.84,1.6,1.29a.38.38,0,0,1-.24.66Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.83,296.66a.42.42,0,0,1-.21-.06c-10.37-6.72-22.46-8-24.78-6.71-.14.07-.3.19-.3.32,0,1.14,1.83,2,3.6,2.72s3.63,1.6,3.63,2.95a.37.37,0,0,1-.37.38.38.38,0,0,1-.38-.38c0-.86-1.62-1.57-3.19-2.26-2-.87-4-1.78-4-3.41a1.12,1.12,0,0,1,.69-1c2.81-1.53,15.54.26,25.55,6.74a.38.38,0,0,1-.2.69Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,292.3a.38.38,0,0,1-.38-.36c-.07-2.11-.1-4.21-.1-6.23,0-.72,0-1.44,0-2.17a.38.38,0,0,1,.38-.37h0a.37.37,0,0,1,.37.38c0,.73,0,1.45,0,2.16,0,2,0,4.1.1,6.2a.38.38,0,0,1-.36.39Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.15,296.66a.38.38,0,0,1-.38-.36c0-.7-.07-1.42-.1-2.14a.38.38,0,0,1,.36-.39.38.38,0,0,1,.39.36c0,.72.06,1.43.1,2.13a.38.38,0,0,1-.35.4Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.61 219.99 212.61 221.66 213.27 222.1 232.06 210.86 230.9 210.72 229.9 209.05 230.33 207.96 211.54 219.2 211.61 219.99",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.27,222.6a.45.45,0,0,1-.27-.08l-.66-.44a.41.41,0,0,1-.16-.16l-1-1.67a.65.65,0,0,1-.07-.21l-.07-.79a.51.51,0,0,1,.24-.48l18.79-11.24a.5.5,0,0,1,.72.61l-.33.86.74,1.25.92.11a.51.51,0,0,1,.43.39.5.5,0,0,1-.23.54l-18.79,11.24A.48.48,0,0,1,213.27,222.6Zm-.29-1.29.31.2,17.33-10.37a.57.57,0,0,1-.15-.16l-1-1.67a.58.58,0,0,1-.07-.21l-17.33,10.37,0,.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.56 207.4 230.33 207.96 229.58 208.75 230.6 210.98 231.61 211.13 232.06 210.86 234.56 207.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.61,211.63h-.08l-1-.16a.5.5,0,0,1-.38-.28l-1-2.24a.51.51,0,0,1,.1-.55l.74-.78a.52.52,0,0,1,.3-.16l4.23-.56a.53.53,0,0,1,.5.24.5.5,0,0,1,0,.55l-2.49,3.46a.5.5,0,0,1-.15.14l-.46.27A.43.43,0,0,1,231.61,211.63Zm-.67-1.1.56.08.22-.13,1.75-2.43-2.9.38-.4.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09,207.59a1.71,1.71,0,0,0,.22.55,2.17,2.17,0,0,0,.38.46l.87-1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.69,209.1a.53.53,0,0,1-.33-.13,2.6,2.6,0,0,1-.48-.57,2.39,2.39,0,0,1-.28-.7.49.49,0,0,1,.08-.39.47.47,0,0,1,.35-.21l1.46-.2a.53.53,0,0,1,.5.24.5.5,0,0,1,0,.55l-.86,1.2a.49.49,0,0,1-.35.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.08,213.82a3.64,3.64,0,0,1,4.39-.58,7.48,7.48,0,0,1,3.36,1.64s2.59-.33,3.25,1.42.39,4.25-.76,4.33a12.22,12.22,0,0,1,0,3.58c-.34,1.19-1.09,3.21-1.09,3.21l.69,5h-8.67l-.5-3s-5.35-7.93-5-11.43a86,86,0,0,0,2.32-8.5c.67-3.27.56-6.22,1.57-6.16,2.25.12,1.65,4.12,1.25,5.44A49,49,0,0,0,219.08,213.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.92,232.88h-8.67a.5.5,0,0,1-.49-.42l-.49-2.88c-.62-.94-5.37-8.2-5-11.67l0-.1c0-.05,1.49-4.52,2.3-8.45.22-1.06.35-2.08.47-3,.28-2.19.46-3.63,1.61-3.57a1.93,1.93,0,0,1,1.53.84c1,1.45.45,4.34.17,5.24a37.13,37.13,0,0,0-.67,3.85,4,4,0,0,1,3.93,0,8.22,8.22,0,0,1,3.37,1.6c.74,0,2.86,0,3.53,1.76a5.45,5.45,0,0,1-.1,4.3,1.54,1.54,0,0,1-.59.56,10.67,10.67,0,0,1-.06,3.37c-.3,1-.89,2.67-1.06,3.13l.67,4.83a.5.5,0,0,1-.49.57Zm-8.25-1h7.67l-.61-4.39a.5.5,0,0,1,0-.24s.75-2,1.08-3.17a11.18,11.18,0,0,0,0-3.38.47.47,0,0,1,.11-.38.49.49,0,0,1,.35-.19s.17,0,.32-.25a4.45,4.45,0,0,0,0-3.4c-.52-1.36-2.7-1.11-2.72-1.1a.5.5,0,0,1-.43-.16,7.24,7.24,0,0,0-3.11-1.5l-.15-.05a3.08,3.08,0,0,0-3.77.5.5.5,0,0,1-.57.1.48.48,0,0,1-.28-.51,45.35,45.35,0,0,1,.85-5.17c.32-1.05.64-3.4,0-4.38a.93.93,0,0,0-.76-.41,8.52,8.52,0,0,0-.57,2.7c-.12.92-.26,2-.48,3.06a87.55,87.55,0,0,1-2.32,8.51c-.25,2.75,3.44,8.89,4.89,11a.5.5,0,0,1,.08.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.25,215.3s2.67-.59,3.75.41c0,0,2.75-.16,4,1.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,217.38a.5.5,0,0,1-.37-.16c-1.07-1.14-3.58-1-3.6-1a.5.5,0,0,1-.37-.13c-.73-.67-2.63-.44-3.3-.29a.52.52,0,0,1-.6-.39.49.49,0,0,1,.38-.59c.29-.06,2.74-.56,4,.4.69,0,3,0,4.19,1.33a.5.5,0,0,1,0,.71A.48.48,0,0,1,226,217.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5,217.88a22.08,22.08,0,0,0,.82,2.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.32,221.13a.5.5,0,0,1-.47-.33A21.2,21.2,0,0,1,228,218a.51.51,0,0,1,.39-.59.5.5,0,0,1,.59.39,20.55,20.55,0,0,0,.8,2.68.5.5,0,0,1-.3.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,249.21c-.3-2.59-.31-8.89,9.33-4.66s18.3,6.83,20.15,9.16a26.27,26.27,0,0,1-2-10.3c.29-5-1.28-12.53-1.28-12.53s6.46-3.34,10.37,0c0,0,4.88,35.17,3.89,36s-11.25-1-20.78-2.17S194.18,259.51,193,249.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.11,267.59a107.79,107.79,0,0,1-11.19-1.27c-2.7-.38-5.5-.77-8.28-1.11-12.15-1.49-19.11-7-20.14-15.94h0c-.32-2.78.26-4.8,1.67-5.84,1.7-1.25,4.51-1,8.36.66,3.26,1.43,6.42,2.68,9.22,3.78a67.53,67.53,0,0,1,9.62,4.28,24.51,24.51,0,0,1-1.37-8.77c.29-4.92-1.25-12.33-1.26-12.4a.5.5,0,0,1,.26-.55c.27-.14,6.8-3.45,10.92.07a.53.53,0,0,1,.17.31c3.26,23.52,4.51,35.78,3.72,36.45A2.84,2.84,0,0,1,232.11,267.59ZM193.5,249.16c1.22,10.65,11.15,14.07,19.26,15.06,2.79.34,5.59.73,8.3,1.11,5.16.72,11,1.54,12,1.19.38-2.14-2.2-22.6-4-35.38-3.12-2.48-8-.57-9.33,0A57.8,57.8,0,0,1,221,243.44a26.13,26.13,0,0,0,1.94,10.08.48.48,0,0,1-.2.62.51.51,0,0,1-.65-.11c-1.14-1.44-5.36-3.11-10.71-5.23-2.8-1.1-6-2.36-9.25-3.79-3.5-1.54-6-1.8-7.37-.78s-1.46,3.25-1.26,4.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,245.63a.28.28,0,0,1-.15,0,.37.37,0,0,1-.19-.49,3.64,3.64,0,0,1,1-1.4.37.37,0,0,1,.52,0,.38.38,0,0,1,0,.53,3.1,3.1,0,0,0-.81,1.14A.38.38,0,0,1,193.37,245.63Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,258.46a.39.39,0,0,1-.27-.12,15.46,15.46,0,0,1-4.09-9.08,10.83,10.83,0,0,1-.07-1.94A.38.38,0,0,1,193,247a.37.37,0,0,1,.35.4,11.38,11.38,0,0,0,.07,1.81,14.69,14.69,0,0,0,3.9,8.66.38.38,0,0,1,0,.53A.4.4,0,0,1,197,258.46Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.53,261.29a.35.35,0,0,1-.19-.06,18.69,18.69,0,0,1-1.92-1.33.38.38,0,0,1-.06-.52.37.37,0,0,1,.53-.07,16.25,16.25,0,0,0,1.84,1.28.38.38,0,0,1-.2.7Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.79,260.8a.37.37,0,0,1-.36-.29s-.64-2.54-3.78-5.57a.38.38,0,0,1,.53-.54c3.31,3.2,3.95,5.83,4,5.94a.38.38,0,0,1-.28.45Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.21,346.59h-36.1a5.56,5.56,0,0,0-5.55,5.55v6.57a3.22,3.22,0,0,0,3.22,3.22h38.43Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.21,362.43H147.78a3.73,3.73,0,0,1-3.72-3.72v-6.57a6.06,6.06,0,0,1,6.05-6.05h36.1a.51.51,0,0,1,.5.5v15.34A.51.51,0,0,1,186.21,362.43Zm-36.1-15.34a5.06,5.06,0,0,0-5.05,5.05v6.57a2.72,2.72,0,0,0,2.72,2.72h37.93V347.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,290.68h-6.24V313h9.8a6.45,6.45,0,0,0,6.45-6.45v-5.87A10,10,0,0,0,175.65,290.68Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.21,313.51h-9.8a.5.5,0,0,1-.5-.5V290.68a.5.5,0,0,1,.5-.5h6.24a10.52,10.52,0,0,1,10.51,10.51v5.87A7,7,0,0,1,179.21,313.51Zm-9.3-1h9.3a6,6,0,0,0,5.95-5.95v-5.87a9.53,9.53,0,0,0-9.51-9.51h-5.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.58,290.68h18a10,10,0,0,1,10,10v5.87a6.45,6.45,0,0,1-6.45,6.45H151a6.45,6.45,0,0,1-6.45-6.45v-5.87a10,10,0,0,1,10-10Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.09,313.51H151a7,7,0,0,1-7-6.95v-5.87a10.52,10.52,0,0,1,10.52-10.51h17.95A10.52,10.52,0,0,1,183,300.69v5.87A7,7,0,0,1,176.09,313.51Zm-21.51-22.33a9.53,9.53,0,0,0-9.52,9.51v5.87a6,6,0,0,0,6,5.95h25.07a6,6,0,0,0,5.95-5.95v-5.87a9.53,9.53,0,0,0-9.51-9.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.54,362.51H164.21a4.06,4.06,0,0,1-4.05-4.05V304.74a.4.4,0,0,1,.39-.4,2.5,2.5,0,0,0,0-5,5.4,5.4,0,0,0-5.39,5.4v53.72a9.06,9.06,0,0,0,9.05,9.05H180v61.08a2.5,2.5,0,0,0,5,0V367.51h8.84a5,5,0,0,0,5-5Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.54,431.59a3,3,0,0,1-3-3V368H164.21a9.56,9.56,0,0,1-9.55-9.55V304.74a5.9,5.9,0,0,1,5.89-5.9,3,3,0,0,1,.11,6v53.62a3.55,3.55,0,0,0,3.55,3.55h34.67a.5.5,0,0,1,.5.5,5.51,5.51,0,0,1-5.5,5.5h-8.34v60.58A3,3,0,0,1,182.54,431.59Zm-22-131.75a4.91,4.91,0,0,0-4.89,4.9v53.72a8.56,8.56,0,0,0,8.55,8.55H180a.5.5,0,0,1,.5.5v61.08a2,2,0,0,0,4,0V367.51a.5.5,0,0,1,.5-.5h8.84a4.5,4.5,0,0,0,4.47-4H164.21a4.55,4.55,0,0,1-4.55-4.55V304.74a.9.9,0,0,1,.89-.9,2,2,0,0,0,0-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,435.55,186.21,432V416.43h-7.34V432l-16.75,3.59a3.72,3.72,0,0,0-3,3.64v.46a1.55,1.55,0,0,0,1.81,1.53l21.56-3.69,21.56,3.69a1.55,1.55,0,0,0,1.81-1.53v-.46A3.72,3.72,0,0,0,203,435.55Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,441.7a2,2,0,0,1-2.05-2.05v-.46a4.25,4.25,0,0,1,3.34-4.13l16.36-3.5V416.43a.5.5,0,0,1,.5-.5h7.34a.5.5,0,0,1,.5.5v15.13l16.36,3.5h0a4.25,4.25,0,0,1,3.34,4.13v.46a2,2,0,0,1-2.39,2L182.54,438l-21.48,3.67A2,2,0,0,1,160.72,441.7Zm18.65-24.77v15a.49.49,0,0,1-.39.49L162.22,436a3.23,3.23,0,0,0-2.55,3.15v.46a1.06,1.06,0,0,0,1.23,1L182.46,437h.16l21.57,3.69a1.06,1.06,0,0,0,.85-.24,1,1,0,0,0,.37-.8v-.46a3.23,3.23,0,0,0-2.55-3.15l-16.76-3.59a.49.49,0,0,1-.39-.49v-15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,358.71h0a12.12,12.12,0,0,0-12.12-12.12H182.79a5.56,5.56,0,0,0-5.55,5.55v6.57a3.22,3.22,0,0,0,3.22,3.22H217.3A3.22,3.22,0,0,0,220.52,358.71Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.3,362.43H180.46a3.73,3.73,0,0,1-3.72-3.72v-6.57a6.06,6.06,0,0,1,6-6.05H208.4A12.63,12.63,0,0,1,221,358.71,3.73,3.73,0,0,1,217.3,362.43Zm-34.51-15.34a5.06,5.06,0,0,0-5,5.05v6.57a2.72,2.72,0,0,0,2.72,2.72H217.3a2.72,2.72,0,0,0,2.72-2.72,11.63,11.63,0,0,0-11.62-11.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elements--inject-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.18,135.75a24.48,24.48,0,0,0,9.87-7.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.18,136.25a.5.5,0,0,1-.18-1,24,24,0,0,0,9.66-7.21.5.5,0,1,1,.78.62,25,25,0,0,1-10.07,7.52A.58.58,0,0,1,343.18,136.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.14,144.73a9.13,9.13,0,0,0,6.11-2.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.14,145.23a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5,8.61,8.61,0,0,0,5.77-2.3.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71,9.64,9.64,0,0,1-6.44,2.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.82,155.71a21.14,21.14,0,0,0,21.41-7.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.36,156.71a22.08,22.08,0,0,1-4.65-.51.5.5,0,0,1-.38-.6.49.49,0,0,1,.59-.38,20.55,20.55,0,0,0,20.91-7.74.49.49,0,0,1,.7-.1.51.51,0,0,1,.1.7A21.75,21.75,0,0,1,315.36,156.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4,155.84a.34.34,0,0,1-.14,0c-.54-.16-1.08-.34-1.61-.54a.51.51,0,0,1-.28-.65.49.49,0,0,1,.64-.28c.5.19,1,.36,1.53.51a.5.5,0,0,1-.14,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.42,117.64c-.4.27-.79.56-1.17.86a10.14,10.14,0,0,0-3.15-.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.25,119a.4.4,0,0,1-.15,0,9.86,9.86,0,0,0-3-.48.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5,10.77,10.77,0,0,1,3,.45c.33-.25.65-.48,1-.71a.5.5,0,1,1,.56.82q-.58.4-1.14.84A.47.47,0,0,1,302.25,119Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.85,112.56a10.19,10.19,0,0,0-.62,3.47c0,.16,0,.33,0,.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25,117a.5.5,0,0,1-.5-.48c0-.18,0-.35,0-.52a10.6,10.6,0,0,1,.65-3.65.5.5,0,0,1,.94.35,9.53,9.53,0,0,0-.59,3.3c0,.16,0,.32,0,.48a.51.51,0,0,1-.48.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.37,104.21a23.51,23.51,0,0,0,1.19,5.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.56,110a.5.5,0,0,1-.47-.33,24.72,24.72,0,0,1-1.22-5.42.5.5,0,0,1,.44-.55.51.51,0,0,1,.55.44,24.46,24.46,0,0,0,1.17,5.2.51.51,0,0,1-.31.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,81.66a24.31,24.31,0,0,0-10.43,20",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.23,102.11a.5.5,0,0,1-.5-.5,24.86,24.86,0,0,1,10.64-20.36.51.51,0,0,1,.7.13.49.49,0,0,1-.13.69,23.85,23.85,0,0,0-10.21,19.54A.5.5,0,0,1,303.23,102.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.73,79a25.28,25.28,0,0,0-2.79,1.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.94,80.75a.52.52,0,0,1-.44-.26.5.5,0,0,1,.2-.68,26,26,0,0,1,2.84-1.32.5.5,0,1,1,.37.93,23.29,23.29,0,0,0-2.73,1.27A.5.5,0,0,1,315.94,80.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.42,81.67a24.19,24.19,0,0,0-13.89-4.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.42,82.17a.52.52,0,0,1-.29-.09,23.64,23.64,0,0,0-13.6-4.28.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5,24.63,24.63,0,0,1,14.18,4.46.5.5,0,0,1,.12.69A.5.5,0,0,1,341.42,82.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.56,85.31a25.89,25.89,0,0,0-2.12-2.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.56,85.81a.49.49,0,0,1-.37-.16,23.43,23.43,0,0,0-2.08-2,.5.5,0,1,1,.66-.76A27,27,0,0,1,345.93,85a.49.49,0,0,1,0,.7A.46.46,0,0,1,345.56,85.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,121a24.29,24.29,0,0,0-5.9-25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,121.52a.41.41,0,0,1-.16,0,.5.5,0,0,1-.32-.63,23.77,23.77,0,0,0-5.77-24.47.5.5,0,0,1,0-.71.51.51,0,0,1,.71,0,25,25,0,0,1,7.32,17.57,24.64,24.64,0,0,1-1.3,7.93A.49.49,0,0,1,357.08,121.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.37,124.91c.36-.66.69-1.33,1-2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.37,125.41a.53.53,0,0,1-.24-.06.51.51,0,0,1-.2-.68c.35-.64.68-1.3,1-2a.5.5,0,0,1,.91.39c-.3.7-.64,1.39-1,2.06A.52.52,0,0,1,355.37,125.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.11 200.83 229.87 180.93 242.98 163.85 264.33 166.66 272.57 186.55 259.46 203.64 238.11 200.83",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.46,204.14h-.06l-21.35-2.81a.5.5,0,0,1-.4-.3l-8.24-19.9a.49.49,0,0,1,.07-.49l13.11-17.09a.5.5,0,0,1,.46-.19l21.35,2.81a.47.47,0,0,1,.39.31L273,186.36a.52.52,0,0,1-.07.5l-13.11,17.08A.48.48,0,0,1,259.46,204.14Zm-21-3.77,20.78,2.73L272,186.48l-8-19.37-20.78-2.73L230.44,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.33 166.66 251.22 183.74 229.87 180.93 242.98 163.85 264.33 166.66",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.22,184.24h-.06l-21.35-2.81a.51.51,0,0,1-.4-.31.49.49,0,0,1,.07-.49l13.11-17.09a.5.5,0,0,1,.46-.19l21.35,2.81a.47.47,0,0,1,.39.31.48.48,0,0,1-.06.49l-13.11,17.09A.51.51,0,0,1,251.22,184.24Zm-20.42-3.69,20.2,2.66L263.41,167l-20.21-2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-60--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "264.33 166.66 251.22 183.74 229.87 180.93 242.98 163.85 264.33 166.66",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "232.31 145.36 219.19 162.44 229.87 180.93 242.98 163.85 232.31 145.36",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87,181.43h0a.48.48,0,0,1-.4-.25l-10.68-18.49a.48.48,0,0,1,0-.55l13.11-17.09a.51.51,0,0,1,.43-.19.5.5,0,0,1,.4.25l10.68,18.49a.5.5,0,0,1,0,.55l-13.11,17.09A.51.51,0,0,1,229.87,181.43Zm-10.08-19L229.93,180l12.45-16.22-10.13-17.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-61--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.31 145.36 219.19 162.44 229.87 180.93 242.98 163.85 232.31 145.36",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "251.22 183.74 259.46 203.64 238.11 200.83 229.87 180.93 251.22 183.74",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.46,204.14h-.06l-21.35-2.81a.5.5,0,0,1-.4-.3l-8.24-19.9a.49.49,0,0,1,.07-.49.46.46,0,0,1,.46-.19l21.35,2.81a.49.49,0,0,1,.39.3l8.25,19.9a.51.51,0,0,1-.07.49A.48.48,0,0,1,259.46,204.14Zm-21-3.77L258.67,203l-7.8-18.83-20.2-2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-62--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "251.22 183.74 259.46 203.64 238.11 200.83 229.87 180.93 251.22 183.74",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "251.22 183.74 229.87 180.93 242.98 163.85 251.22 183.74",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.22,184.24h-.06l-21.35-2.81a.51.51,0,0,1-.4-.31.49.49,0,0,1,.07-.49l13.11-17.09a.5.5,0,0,1,.46-.19.49.49,0,0,1,.39.3l8.24,19.9a.5.5,0,0,1-.06.5A.51.51,0,0,1,251.22,184.24Zm-20.42-3.69,19.63,2.58-7.58-18.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,113.25a20.85,20.85,0,0,0-6.88-15.49,20.93,20.93,0,1,0-38.46,14.68,6.75,6.75,0,0,0-1,3.59,6.67,6.67,0,0,0,.46,2.45,17.61,17.61,0,0,0-6.24,4,6.75,6.75,0,0,0-10.48,5.63,6.92,6.92,0,0,0,.19,1.59,14.1,14.1,0,0,0-12.27,13.65,11.47,11.47,0,0,0-6.58,3.88,6.75,6.75,0,0,0-11.17,7.26,6,6,0,0,0-1.13,1.17,5.68,5.68,0,0,0-3.77-1.44,6,6,0,0,0-.61.06A11.49,11.49,0,1,0,238.71,168a6.73,6.73,0,0,0-.26,10,6.56,6.56,0,0,0-1.57,3.91L250,183.58a6.72,6.72,0,0,0,.14-1.35,6.59,6.59,0,0,0-1.94-4.68,6.64,6.64,0,0,0,1.48-6.23,11.48,11.48,0,0,0,7.51-5.61c.15,0,.3,0,.47,0a5.78,5.78,0,0,0,4.69-2.43,5.74,5.74,0,0,0,9.54-4.32,11.49,11.49,0,0,0,16.24,5.67,6.75,6.75,0,1,0,11-7.71,14.17,14.17,0,0,0,7.6-6.41A17.74,17.74,0,0,0,332.09,141a5.75,5.75,0,0,0,7.31-7.53,21,21,0,0,0,13-10.18A20.69,20.69,0,0,0,355,113.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,184.08h-.07l-13.08-1.72a.5.5,0,0,1-.43-.52,7,7,0,0,1,1.4-3.85,7.23,7.23,0,0,1,.23-10,12,12,0,1,1,19.26-14.18l.35,0a6.2,6.2,0,0,1,3.69,1.23,6.92,6.92,0,0,1,.61-.6,7.15,7.15,0,0,1-.48-2.58,7.24,7.24,0,0,1,12.23-5.27,12.07,12.07,0,0,1,6.12-3.56A14.69,14.69,0,0,1,292,129.29a6.68,6.68,0,0,1-.1-1.17,7.25,7.25,0,0,1,10.91-6.26,18,18,0,0,1,5.68-3.67,7.21,7.21,0,0,1-.33-2.16,7.3,7.3,0,0,1,.95-3.59,21.42,21.42,0,1,1,39.5-14.94,21.39,21.39,0,0,1-8.51,36.3,6.46,6.46,0,0,1,.26,1.79,6.28,6.28,0,0,1-6.26,6.27,6,6,0,0,1-1.66-.24,18.24,18.24,0,0,1-25.53,9.61,14.59,14.59,0,0,1-7,6,7.25,7.25,0,1,1-12,8.16,12,12,0,0,1-15.79-4.66,6.24,6.24,0,0,1-9.73,3.35,6.28,6.28,0,0,1-4.77,2.22h-.21a12,12,0,0,1-7.17,5.44,7.12,7.12,0,0,1-1.41,5.84,7.12,7.12,0,0,1,1.62,6.15A.51.51,0,0,1,250,184.08Zm-12.54-2.66,12.13,1.6a7,7,0,0,0,0-.79,6.08,6.08,0,0,0-1.79-4.32.5.5,0,0,1,0-.69,6.25,6.25,0,0,0,1.59-4.15,6.57,6.57,0,0,0-.22-1.62.46.46,0,0,1,.05-.38.5.5,0,0,1,.32-.23,11,11,0,0,0,7.18-5.37.48.48,0,0,1,.48-.26l.2,0,.23,0A5.27,5.27,0,0,0,261.9,163a.5.5,0,0,1,.35-.21.47.47,0,0,1,.38.12,5.24,5.24,0,0,0,8.72-3.94.5.5,0,0,1,1-.19,11,11,0,0,0,15.53,5.43.53.53,0,0,1,.39-.05.59.59,0,0,1,.3.24,6.25,6.25,0,1,0,10.17-7.14.51.51,0,0,1,.21-.8,13.62,13.62,0,0,0,7.33-6.19.47.47,0,0,1,.3-.23.5.5,0,0,1,.38,0,17.24,17.24,0,0,0,24.7-9.29.5.5,0,0,1,.64-.31,5.06,5.06,0,0,0,1.79.34,5.27,5.27,0,0,0,5.26-5.27,5.08,5.08,0,0,0-.38-1.94.53.53,0,0,1,0-.41.52.52,0,0,1,.32-.26,20.39,20.39,0,0,0,8.49-34.85.53.53,0,0,1-.16-.28,20.42,20.42,0,1,0-37.53,14.33.51.51,0,0,1,0,.53,6.22,6.22,0,0,0-.53,5.59.5.5,0,0,1,0,.38.51.51,0,0,1-.28.26,17.25,17.25,0,0,0-6.07,3.9.5.5,0,0,1-.63.07,6.25,6.25,0,0,0-9.7,5.21,6.29,6.29,0,0,0,.18,1.47.51.51,0,0,1-.08.4.49.49,0,0,1-.34.22,13.68,13.68,0,0,0-11.84,13.16.5.5,0,0,1-.4.48,11,11,0,0,0-6.3,3.71.49.49,0,0,1-.37.18.5.5,0,0,1-.38-.16,6.24,6.24,0,0,0-10.88,4.2,6.11,6.11,0,0,0,.54,2.52.51.51,0,0,1-.15.6,5.14,5.14,0,0,0-1,1.06.53.53,0,0,1-.35.21.51.51,0,0,1-.38-.12,5.27,5.27,0,0,0-3.45-1.32,2,2,0,0,0-.35,0l-.21,0a.5.5,0,0,1-.48-.25,11,11,0,1,0-17.51,13.08.5.5,0,0,1,.14.37.53.53,0,0,1-.17.35,6.23,6.23,0,0,0-.25,9.24.5.5,0,0,1,0,.69A6.11,6.11,0,0,0,237.42,181.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.73 125.9 223.24 103.89 252.6 91.24 232.73 125.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,126.4h0a.5.5,0,0,1-.43-.3l-9.49-22a.5.5,0,0,1,0-.38.46.46,0,0,1,.26-.27L252.4,90.78a.49.49,0,0,1,.57.12.5.5,0,0,1,.06.58l-19.87,34.67A.52.52,0,0,1,232.73,126.4Zm-8.83-22.25,8.89,20.63,18.63-32.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.91 122.28 224.43 100.27 253.78 87.62 233.91 122.28",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,122.78h0a.5.5,0,0,1-.43-.3l-9.49-22a.58.58,0,0,1,0-.39.51.51,0,0,1,.27-.27l29.36-12.65a.49.49,0,0,1,.57.12.51.51,0,0,1,.06.59l-19.87,34.66A.52.52,0,0,1,233.91,122.78Zm-8.82-22.25L234,121.16l18.63-32.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.43,130a12,12,0,1,1-22.07-9.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.38,137.69a12.53,12.53,0,0,1-11.48-17.53.51.51,0,0,1,.66-.26l22.07,9.6a.49.49,0,0,1,.26.66A12.55,12.55,0,0,1,265.38,137.69ZM254.63,121a11.54,11.54,0,0,0,21.14,9.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,126.34a12,12,0,1,1-22.07-9.6Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.57,134.08a12.54,12.54,0,0,1-11.48-17.54.49.49,0,0,1,.27-.26.53.53,0,0,1,.39,0l22.07,9.6a.5.5,0,0,1,.26.66A12.55,12.55,0,0,1,266.57,134.08Zm-10.75-16.67A11.53,11.53,0,0,0,277,126.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-63--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.62,126.34a12,12,0,1,1-22.07-9.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 273.37,
    y: 92.37,
    width: 16.43,
    height: 16.43,
    transform: "translate(153.6 -169.65) rotate(45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.59,112.71a.53.53,0,0,1-.36-.15l-11.62-11.62a.51.51,0,0,1,0-.71l11.62-11.62a.51.51,0,0,1,.71,0l11.62,11.62a.51.51,0,0,1,0,.71l-11.62,11.62A.51.51,0,0,1,281.59,112.71Zm-10.92-12.12,10.92,10.91,10.91-10.91L281.59,89.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.56,
    y: 88.75,
    width: 16.43,
    height: 16.43,
    transform: "translate(151.39 -171.55) rotate(45)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.77,109.09a.51.51,0,0,1-.35-.15L270.8,97.32a.51.51,0,0,1,0-.71L282.42,85a.5.5,0,0,1,.71,0l11.62,11.61a.51.51,0,0,1,0,.71l-11.62,11.62A.53.53,0,0,1,282.77,109.09ZM271.86,97l10.91,10.91L293.69,97,282.77,86.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-64--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.56,
    y: 88.75,
    width: 16.43,
    height: 16.43,
    transform: "translate(151.39 -171.55) rotate(45)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.79,103a30.27,30.27,0,0,0-60.12,7.1c1.42,12,12,19.06,19.15,27.88,2.23,2.73,3.33,13.8,3.33,13.8l25.49-3s-1.51-11,0-14.19C185.59,124.33,194.21,115,192.79,103Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.15,152.28a.49.49,0,0,1-.5-.45c0-.11-1.11-11-3.21-13.53-1.91-2.34-4.1-4.6-6.22-6.79-5.89-6.08-12-12.36-13-21.35a30.77,30.77,0,1,1,61.11-7.22h0c1.06,9-3.4,16.52-7.72,23.81-1.55,2.62-3.15,5.32-4.46,8-1.44,3,0,13.8,0,13.91a.49.49,0,0,1-.1.37.47.47,0,0,1-.34.19l-25.5,3Zm7.64-75.5a30.32,30.32,0,0,0-3.55.21A29.79,29.79,0,0,0,133.17,110c1,8.66,7,14.82,12.77,20.78,2.13,2.2,4.34,4.47,6.27,6.85s3.13,11.31,3.38,13.55l24.49-2.89c-.28-2.24-1.27-11.06.13-14s2.94-5.49,4.5-8.12c4.23-7.14,8.6-14.52,7.58-23.18h0a29.76,29.76,0,0,0-29.5-26.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-65--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.79,103a30.27,30.27,0,0,0-60.12,7.1c1.42,12,12,19.06,19.15,27.88,2.23,2.73,3.33,13.8,3.33,13.8l25.49-3s-1.51-11,0-14.19C185.59,124.33,194.21,115,192.79,103Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,158.65l-10.88,1.28a7.35,7.35,0,0,1-8.17-6.44h0l25.5-3h0A7.37,7.37,0,0,1,174.4,158.65Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.65,160.48a7.86,7.86,0,0,1-7.8-6.93.5.5,0,0,1,.11-.37.53.53,0,0,1,.33-.19l25.5-3a.44.44,0,0,1,.36.11.45.45,0,0,1,.19.33,7.86,7.86,0,0,1-6.88,8.72l-.06-.49.06.49-10.89,1.29A7.19,7.19,0,0,1,162.65,160.48Zm-6.73-6.55a6.87,6.87,0,0,0,7.54,5.51l10.88-1.29a6.86,6.86,0,0,0,6-7.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,167h0a6,6,0,0,1-6.66-5.26h0l11.92-1.4h0A6,6,0,0,1,169.86,167Z",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.16,167.5a6.51,6.51,0,0,1-6.45-5.74.49.49,0,0,1,.43-.55l11.92-1.41a.49.49,0,0,1,.37.1.58.58,0,0,1,.19.34,6.51,6.51,0,0,1-5.7,7.22h0A6.45,6.45,0,0,1,169.16,167.5Zm-5.38-5.36a5.49,5.49,0,0,0,6,4.32h0a5.5,5.5,0,0,0,4.85-5.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,134.11a.51.51,0,0,1-.5-.5v-4a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v4A.5.5,0,0,1,162.77,134.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,127.05a.5.5,0,0,1-.5-.5V114.41a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v12.14A.5.5,0,0,1,162.77,127.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,99.91a.5.5,0,0,1-.5-.5V97.19a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.22A.5.5,0,0,1,162.77,99.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,95.72a.51.51,0,0,1-.5-.5V84.54a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V95.22A.5.5,0,0,1,162.77,95.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,82.75a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2A.5.5,0,0,1,162.77,82.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.25,107.41H136.08a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h14.17a.5.5,0,0,1,.5.5A.5.5,0,0,1,150.25,107.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.27,107.41h-2.54a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.54a.5.5,0,0,1,.5.5A.5.5,0,0,1,155.27,107.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.56,107.41h-2.29a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.29a.5.5,0,0,1,.5.5A.5.5,0,0,1,172.56,107.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,107.41h-4.07a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.07a.51.51,0,0,1,.5.5A.5.5,0,0,1,178.54,107.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.47,107.41H181a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h8.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,189.47,107.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.9,126.29a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l1.93-1.93a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-1.92,1.92A.49.49,0,0,1,143.9,126.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,123a.47.47,0,0,1-.35-.15.5.5,0,0,1,0-.71l7.78-7.78a.5.5,0,0,1,.71,0,.48.48,0,0,1,0,.7l-7.79,7.79A.47.47,0,0,1,147.17,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2,114a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l1.28-1.28a.5.5,0,1,1,.71.71l-1.28,1.27A.5.5,0,0,1,156.2,114Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,102.11a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7L175,93.94a.5.5,0,0,1,.71.71L168.43,102A.49.49,0,0,1,168.08,102.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2,93a.5.5,0,0,1-.35-.85l4.45-4.45a.5.5,0,1,1,.71.71l-4.45,4.45A.5.5,0,0,1,177.2,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.24,91.87a.54.54,0,0,1-.36-.14l-3.34-3.34a.5.5,0,1,1,.71-.71L147.59,91a.51.51,0,0,1,0,.71A.54.54,0,0,1,147.24,91.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,102.11a.49.49,0,0,1-.35-.15l-8.81-8.8a.51.51,0,0,1,0-.71.5.5,0,0,1,.71,0l8.8,8.81a.48.48,0,0,1,0,.7A.47.47,0,0,1,157.47,102.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61,114.25a.51.51,0,0,1-.36-.15l-1.52-1.53a.48.48,0,0,1,0-.7.5.5,0,0,1,.71,0l1.52,1.52a.5.5,0,0,1,0,.71A.49.49,0,0,1,169.61,114.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,120.83a.54.54,0,0,1-.36-.14l-5.19-5.19a.51.51,0,0,1,0-.71.5.5,0,0,1,.71,0l5.19,5.19a.51.51,0,0,1,0,.71A.54.54,0,0,1,176.2,120.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,126.29a.49.49,0,0,1-.35-.15l-3.85-3.84a.5.5,0,0,1,.71-.71l3.85,3.85a.5.5,0,0,1,0,.7A.51.51,0,0,1,181.65,126.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,170a.5.5,0,0,1-.46-.31l-3.89-9.39a.49.49,0,0,1,.27-.65.5.5,0,0,1,.65.27l3.89,9.39a.49.49,0,0,1-.27.65A.43.43,0,0,1,188.7,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.85,153.46a.5.5,0,0,1-.46-.31L169.6,124.69a.5.5,0,0,1,.27-.66.51.51,0,0,1,.65.27l11.79,28.47a.5.5,0,0,1-.27.65A.43.43,0,0,1,181.85,153.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49,89.83a.51.51,0,0,1-.46-.31l-2.16-5.21a.5.5,0,0,1,.27-.66.51.51,0,0,1,.65.27L156,89.14a.49.49,0,0,1-.27.65A.41.41,0,0,1,155.49,89.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.42,80a.49.49,0,0,1-.46-.3l-10.37-25a.5.5,0,0,1,.92-.38l10.37,25a.52.52,0,0,1-.27.66A.63.63,0,0,1,151.42,80Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,49.6a.51.51,0,0,1-.47-.31l-2-4.77a.5.5,0,0,1,.27-.66.51.51,0,0,1,.65.27l2,4.77a.52.52,0,0,1-.27.66A.65.65,0,0,1,138.83,49.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.19,133.34a.5.5,0,0,1-.46-.31.49.49,0,0,1,.27-.65l33.23-13.77a.51.51,0,0,1,.65.27.49.49,0,0,1-.27.65L100.38,133.3A.65.65,0,0,1,100.19,133.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.23,117.17a.5.5,0,0,1-.19-1l6-2.47a.51.51,0,0,1,.65.27.5.5,0,0,1-.27.66l-6,2.47A.65.65,0,0,1,139.23,117.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,100.13a.5.5,0,0,1-.46-.31.49.49,0,0,1,.27-.65L185.53,97a.49.49,0,0,1,.65.27.49.49,0,0,1-.27.65l-5.36,2.22A.43.43,0,0,1,180.36,100.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.19,96.06a.51.51,0,0,1-.46-.31.52.52,0,0,1,.27-.66l9.54-4a.51.51,0,0,1,.65.27.5.5,0,0,1-.27.66l-9.54,4A.58.58,0,0,1,190.19,96.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.39,89.76a.51.51,0,0,1-.46-.31.5.5,0,0,1,.27-.65l20-8.27a.5.5,0,0,1,.38.92l-20,8.27A.41.41,0,0,1,205.39,89.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.85,170a.43.43,0,0,1-.19,0,.49.49,0,0,1-.27-.65l2.64-6.38a.51.51,0,0,1,.65-.27.5.5,0,0,1,.27.66l-2.64,6.37A.5.5,0,0,1,136.85,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.34,159.15a.46.46,0,0,1-.19,0,.51.51,0,0,1-.27-.65l10.7-25.82a.5.5,0,1,1,.92.39l-10.69,25.81A.51.51,0,0,1,141.34,159.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,129.22a.63.63,0,0,1-.19,0,.5.5,0,0,1-.27-.66l1.75-4.22a.5.5,0,1,1,.92.38l-1.75,4.23A.49.49,0,0,1,153.74,129.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06,89.83a.41.41,0,0,1-.19,0,.49.49,0,0,1-.27-.65l10-24.25a.5.5,0,0,1,.92.38l-10,24.25A.51.51,0,0,1,170.06,89.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59,59.57a.63.63,0,0,1-.19,0,.5.5,0,0,1-.27-.66l6.11-14.75a.51.51,0,0,1,.65-.27.5.5,0,0,1,.27.66l-6.11,14.75A.49.49,0,0,1,182.59,59.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,86.07a.46.46,0,0,1-.19,0L100,81.45a.5.5,0,1,1,.38-.92l11.07,4.58a.51.51,0,0,1,.27.65A.5.5,0,0,1,111.25,86.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,100.13a.43.43,0,0,1-.19,0L115.8,88a.5.5,0,0,1-.27-.66.51.51,0,0,1,.65-.27l29.2,12.1a.49.49,0,0,1,.27.65A.5.5,0,0,1,145.19,100.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.43,116.8a.43.43,0,0,1-.19,0l-5.06-2.1a.5.5,0,0,1,.38-.92l5.06,2.1a.49.49,0,0,1,.27.65A.5.5,0,0,1,185.43,116.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.27,125.84a.63.63,0,0,1-.19,0l-17.21-7.13a.5.5,0,0,1,.38-.93l17.21,7.13a.5.5,0,0,1,.27.66A.49.49,0,0,1,207.27,125.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.36,133.34a.65.65,0,0,1-.19,0L212.42,128a.5.5,0,0,1,.39-.93l12.74,5.29a.49.49,0,0,1,.27.65A.5.5,0,0,1,225.36,133.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.64,188l-2.1-.81,3.34-8.65a1.46,1.46,0,0,0-.83-1.88l-6.21-2.39a3.72,3.72,0,0,1-2.12-4.79l2.4-6.2a1.46,1.46,0,0,0-.83-1.88l-6.21-2.4A3.71,3.71,0,0,1,117,154.2l2.4-6.2a1.46,1.46,0,0,0-.83-1.88l-6.21-2.4a3.71,3.71,0,0,1-2.12-4.78l2.4-6.21a1.45,1.45,0,0,0-.83-1.88l-8.64-3.34.81-2.09,8.64,3.34a3.71,3.71,0,0,1,2.12,4.78l-2.4,6.21a1.46,1.46,0,0,0,.83,1.88l6.21,2.39a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.2a1.46,1.46,0,0,0,.83,1.88l6.21,2.4a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.2a1.45,1.45,0,0,0,.83,1.88l6.21,2.4a3.71,3.71,0,0,1,2.12,4.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.64,188.49a.39.39,0,0,1-.18,0l-2.1-.81a.55.55,0,0,1-.28-.26.5.5,0,0,1,0-.38l3.33-8.65a1,1,0,0,0-.54-1.23l-6.21-2.4a4.21,4.21,0,0,1-2.4-5.43l2.39-6.2a1,1,0,0,0-.54-1.24l-6.21-2.39a4.22,4.22,0,0,1-2.4-5.44l2.39-6.2a1,1,0,0,0,0-.73,1,1,0,0,0-.53-.5l-6.21-2.4a4.21,4.21,0,0,1-2.4-5.43l2.39-6.21a.93.93,0,0,0,0-.73,1,1,0,0,0-.53-.5L103,128a.5.5,0,0,1-.29-.65l.81-2.09a.48.48,0,0,1,.26-.28.52.52,0,0,1,.39,0l8.64,3.34a4.2,4.2,0,0,1,2.4,5.43l-2.39,6.21a1,1,0,0,0,.54,1.23l6.21,2.4a4.2,4.2,0,0,1,2.4,5.43l-2.39,6.2a1,1,0,0,0,.54,1.24l6.21,2.39A4.21,4.21,0,0,1,128.6,161a4.14,4.14,0,0,1,.08,3.22l-2.39,6.2a.93.93,0,0,0,0,.73,1,1,0,0,0,.52.51l6.21,2.39a4.2,4.2,0,0,1,2.4,5.43l-3.34,8.65A.5.5,0,0,1,131.64,188.49Zm-1.45-1.6,1.16.45,3.16-8.18a3.16,3.16,0,0,0-.06-2.45,3.22,3.22,0,0,0-1.77-1.69l-6.21-2.39a2,2,0,0,1-1.12-2.53l2.4-6.2a3.2,3.2,0,0,0-1.83-4.14l-6.21-2.4a2,2,0,0,1-1.12-2.53l2.4-6.2a3.21,3.21,0,0,0-1.83-4.14l-6.21-2.4a2,2,0,0,1-1.12-2.52l2.4-6.21a3.16,3.16,0,0,0-.06-2.45,3.22,3.22,0,0,0-1.77-1.69l-8.18-3.16-.45,1.17,8.18,3.16a1.92,1.92,0,0,1,1.08,1,2,2,0,0,1,0,1.49l-2.4,6.21a3.21,3.21,0,0,0,1.83,4.14l6.21,2.39a2,2,0,0,1,1.12,2.53l-2.4,6.2a3.21,3.21,0,0,0,1.83,4.14l6.21,2.4a2,2,0,0,1,1.12,2.53l-2.4,6.2a3.16,3.16,0,0,0,.06,2.45,3.22,3.22,0,0,0,1.77,1.69l6.21,2.4a2,2,0,0,1,1.12,2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.64,188l-2.1-.81,3.34-8.65a1.46,1.46,0,0,0-.83-1.88l-6.21-2.39a3.72,3.72,0,0,1-2.12-4.79l2.4-6.2a1.46,1.46,0,0,0-.83-1.88l-6.21-2.4A3.71,3.71,0,0,1,117,154.2l2.4-6.2a1.46,1.46,0,0,0-.83-1.88l-6.21-2.4a3.71,3.71,0,0,1-2.12-4.78l2.4-6.21a1.45,1.45,0,0,0-.83-1.88l-8.64-3.34.81-2.09,8.64,3.34a3.71,3.71,0,0,1,2.12,4.78l-2.4,6.21a1.46,1.46,0,0,0,.83,1.88l6.21,2.39a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.2a1.46,1.46,0,0,0,.83,1.88l6.21,2.4a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.2a1.45,1.45,0,0,0,.83,1.88l6.21,2.4a3.71,3.71,0,0,1,2.12,4.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.64,188.49a.39.39,0,0,1-.18,0l-2.1-.81a.55.55,0,0,1-.28-.26.5.5,0,0,1,0-.38l3.33-8.65a1,1,0,0,0-.54-1.23l-6.21-2.4a4.21,4.21,0,0,1-2.4-5.43l2.39-6.2a1,1,0,0,0-.54-1.24l-6.21-2.39a4.22,4.22,0,0,1-2.4-5.44l2.39-6.2a1,1,0,0,0,0-.73,1,1,0,0,0-.53-.5l-6.21-2.4a4.21,4.21,0,0,1-2.4-5.43l2.39-6.21a.93.93,0,0,0,0-.73,1,1,0,0,0-.53-.5L103,128a.5.5,0,0,1-.29-.65l.81-2.09a.48.48,0,0,1,.26-.28.52.52,0,0,1,.39,0l8.64,3.34a4.2,4.2,0,0,1,2.4,5.43l-2.39,6.21a1,1,0,0,0,.54,1.23l6.21,2.4a4.2,4.2,0,0,1,2.4,5.43l-2.39,6.2a1,1,0,0,0,.54,1.24l6.21,2.39A4.21,4.21,0,0,1,128.6,161a4.14,4.14,0,0,1,.08,3.22l-2.39,6.2a.93.93,0,0,0,0,.73,1,1,0,0,0,.52.51l6.21,2.39a4.2,4.2,0,0,1,2.4,5.43l-3.34,8.65A.5.5,0,0,1,131.64,188.49Zm-1.45-1.6,1.16.45,3.16-8.18a3.16,3.16,0,0,0-.06-2.45,3.22,3.22,0,0,0-1.77-1.69l-6.21-2.39a2,2,0,0,1-1.12-2.53l2.4-6.2a3.2,3.2,0,0,0-1.83-4.14l-6.21-2.4a2,2,0,0,1-1.12-2.53l2.4-6.2a3.21,3.21,0,0,0-1.83-4.14l-6.21-2.4a2,2,0,0,1-1.12-2.52l2.4-6.21a3.16,3.16,0,0,0-.06-2.45,3.22,3.22,0,0,0-1.77-1.69l-8.18-3.16-.45,1.17,8.18,3.16a1.92,1.92,0,0,1,1.08,1,2,2,0,0,1,0,1.49l-2.4,6.21a3.21,3.21,0,0,0,1.83,4.14l6.21,2.39a2,2,0,0,1,1.12,2.53l-2.4,6.2a3.21,3.21,0,0,0,1.83,4.14l6.21,2.4a2,2,0,0,1,1.12,2.53l-2.4,6.2a3.16,3.16,0,0,0,.06,2.45,3.22,3.22,0,0,0,1.77,1.69l6.21,2.4a2,2,0,0,1,1.12,2.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,185.86l-2.1-.81,3.34-8.65a1.45,1.45,0,0,0-.83-1.88l-6.2-2.39a3.7,3.7,0,0,1-2.12-4.79l2.39-6.2a1.45,1.45,0,0,0-.83-1.88l-6.2-2.4a3.7,3.7,0,0,1-2.12-4.79l2.39-6.2a1.45,1.45,0,0,0-.83-1.88l-6.2-2.4a3.69,3.69,0,0,1-2.12-4.78l2.39-6.21a1.45,1.45,0,0,0-.83-1.88L104,125.38l.81-2.09,8.64,3.33a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.21a1.46,1.46,0,0,0,.84,1.88l6.2,2.39a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.2a1.46,1.46,0,0,0,.84,1.88l6.2,2.4A3.71,3.71,0,0,1,129,162l-2.4,6.2a1.46,1.46,0,0,0,.84,1.88l6.2,2.4a3.71,3.71,0,0,1,2.12,4.78Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,186.36a.58.58,0,0,1-.18,0l-2.1-.81a.49.49,0,0,1-.27-.26.46.46,0,0,1,0-.38l3.34-8.65a1,1,0,0,0-.55-1.23l-6.2-2.4a4.2,4.2,0,0,1-2.41-5.43l2.4-6.2a1,1,0,0,0,0-.73,1,1,0,0,0-.53-.51l-6.2-2.39a4.21,4.21,0,0,1-2.41-5.44l2.4-6.2a1,1,0,0,0-.55-1.23l-6.2-2.4a4.13,4.13,0,0,1-2.33-2.22,4.2,4.2,0,0,1-.08-3.21l2.4-6.21a1,1,0,0,0-.55-1.23l-8.64-3.34a.55.55,0,0,1-.28-.26.52.52,0,0,1,0-.39l.81-2.09a.5.5,0,0,1,.65-.29l8.64,3.34a4.21,4.21,0,0,1,2.41,5.43l-2.4,6.21a1,1,0,0,0,.55,1.23l6.2,2.4a4.21,4.21,0,0,1,2.41,5.43l-2.4,6.2a1,1,0,0,0,.55,1.24l6.2,2.39a4.22,4.22,0,0,1,2.41,5.44l-2.4,6.2a1,1,0,0,0,.55,1.23l6.2,2.4a4.21,4.21,0,0,1,2.41,5.43L132.93,186A.52.52,0,0,1,132.46,186.36Zm-1.45-1.6,1.16.45,3.16-8.18a3.16,3.16,0,0,0-.06-2.45,3.22,3.22,0,0,0-1.77-1.69l-6.2-2.39a2,2,0,0,1-1.12-2.53l2.39-6.2a3.19,3.19,0,0,0-1.83-4.14l-6.2-2.4a2,2,0,0,1-1.12-2.53l2.39-6.2a3.2,3.2,0,0,0-1.83-4.14l-6.2-2.4a2,2,0,0,1-1.12-2.52l2.39-6.21a3.21,3.21,0,0,0-1.83-4.14L105,123.93l-.44,1.17,8.17,3.16a1.94,1.94,0,0,1,1.12,2.52l-2.4,6.21a3.25,3.25,0,0,0,.06,2.45,3.21,3.21,0,0,0,1.78,1.69l6.2,2.39a2,2,0,0,1,1.12,2.53l-2.4,6.2a3.25,3.25,0,0,0,.06,2.45,3.14,3.14,0,0,0,1.78,1.69l6.2,2.4a1.92,1.92,0,0,1,1.08,1,2,2,0,0,1,0,1.5l-2.4,6.2a3.21,3.21,0,0,0,1.84,4.14l6.2,2.4a2,2,0,0,1,1.12,2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.46,185.86l-2.1-.81,3.34-8.65a1.45,1.45,0,0,0-.83-1.88l-6.2-2.39a3.7,3.7,0,0,1-2.12-4.79l2.39-6.2a1.45,1.45,0,0,0-.83-1.88l-6.2-2.4a3.7,3.7,0,0,1-2.12-4.79l2.39-6.2a1.45,1.45,0,0,0-.83-1.88l-6.2-2.4a3.69,3.69,0,0,1-2.12-4.78l2.39-6.21a1.45,1.45,0,0,0-.83-1.88L104,125.38l.81-2.09,8.64,3.33a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.21a1.46,1.46,0,0,0,.84,1.88l6.2,2.39a3.72,3.72,0,0,1,2.12,4.79l-2.4,6.2a1.46,1.46,0,0,0,.84,1.88l6.2,2.4A3.71,3.71,0,0,1,129,162l-2.4,6.2a1.46,1.46,0,0,0,.84,1.88l6.2,2.4a3.71,3.71,0,0,1,2.12,4.78Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,186.36a.58.58,0,0,1-.18,0l-2.1-.81a.49.49,0,0,1-.27-.26.46.46,0,0,1,0-.38l3.34-8.65a1,1,0,0,0-.55-1.23l-6.2-2.4a4.2,4.2,0,0,1-2.41-5.43l2.4-6.2a1,1,0,0,0,0-.73,1,1,0,0,0-.53-.51l-6.2-2.39a4.21,4.21,0,0,1-2.41-5.44l2.4-6.2a1,1,0,0,0-.55-1.23l-6.2-2.4a4.13,4.13,0,0,1-2.33-2.22,4.2,4.2,0,0,1-.08-3.21l2.4-6.21a1,1,0,0,0-.55-1.23l-8.64-3.34a.55.55,0,0,1-.28-.26.52.52,0,0,1,0-.39l.81-2.09a.5.5,0,0,1,.65-.29l8.64,3.34a4.21,4.21,0,0,1,2.41,5.43l-2.4,6.21a1,1,0,0,0,.55,1.23l6.2,2.4a4.21,4.21,0,0,1,2.41,5.43l-2.4,6.2a1,1,0,0,0,.55,1.24l6.2,2.39a4.22,4.22,0,0,1,2.41,5.44l-2.4,6.2a1,1,0,0,0,.55,1.23l6.2,2.4a4.21,4.21,0,0,1,2.41,5.43L132.93,186A.52.52,0,0,1,132.46,186.36Zm-1.45-1.6,1.16.45,3.16-8.18a3.16,3.16,0,0,0-.06-2.45,3.22,3.22,0,0,0-1.77-1.69l-6.2-2.39a2,2,0,0,1-1.12-2.53l2.39-6.2a3.19,3.19,0,0,0-1.83-4.14l-6.2-2.4a2,2,0,0,1-1.12-2.53l2.39-6.2a3.2,3.2,0,0,0-1.83-4.14l-6.2-2.4a2,2,0,0,1-1.12-2.52l2.39-6.21a3.21,3.21,0,0,0-1.83-4.14L105,123.93l-.44,1.17,8.17,3.16a1.94,1.94,0,0,1,1.12,2.52l-2.4,6.21a3.25,3.25,0,0,0,.06,2.45,3.21,3.21,0,0,0,1.78,1.69l6.2,2.39a2,2,0,0,1,1.12,2.53l-2.4,6.2a3.25,3.25,0,0,0,.06,2.45,3.14,3.14,0,0,0,1.78,1.69l6.2,2.4a1.92,1.92,0,0,1,1.08,1,2,2,0,0,1,0,1.5l-2.4,6.2a3.21,3.21,0,0,0,1.84,4.14l6.2,2.4a2,2,0,0,1,1.12,2.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.89,104.84s-24.08-25.78-13-33.61S387.89,104.84,387.89,104.84Z",
    style: {
      fill: "#92E3A9"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.46,106.18l-.93-1c-.7-.74-17.1-18.43-16-29a7.24,7.24,0,0,1,3.06-5.35,4.38,4.38,0,0,1,4.65-.67c7.61,3.71,9.11,33.41,9.17,34.67ZM377.52,70.75a4.12,4.12,0,0,0-2.37.89,6.13,6.13,0,0,0-2.64,4.64c-.89,8.69,11.26,23.16,14.8,27.17-.4-6-2.34-29.39-8.53-32.4A2.84,2.84,0,0,0,377.52,70.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-66--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.89,104.84s-24.08-25.78-13-33.61S387.89,104.84,387.89,104.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,182.49s-24.84,1.75-24.22-7.78S225.7,182.49,225.7,182.49Z",
    style: {
      fill: "#92E3A9"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.21,183.13c-5.62,0-14.9-.6-18.61-4.28a5.21,5.21,0,0,1-1.62-4.17,3.22,3.22,0,0,1,1.78-3c5.49-2.57,22.51,9.85,23.23,10.38l1.1.81-1.36.09C225.51,183,223.73,183.13,221.21,183.13Zm-16.58-10.79a3.38,3.38,0,0,0-1.45.27,2.26,2.26,0,0,0-1.2,2.13,4.23,4.23,0,0,0,1.32,3.4c4.19,4.16,16.7,4.08,20.94,3.92C219.32,178.6,209.4,172.34,204.63,172.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-67--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.7,182.49s-24.84,1.75-24.22-7.78S225.7,182.49,225.7,182.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.17,130.05s-5.7-46.06,9.26-45.4S396.17,130.05,396.17,130.05Z",
    style: {
      fill: "#92E3A9"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.87,131.66l-.19-1.55c-.18-1.4-4.16-34.49,4.28-43.62a6.85,6.85,0,0,1,5.5-2.34,4.93,4.93,0,0,1,4.37,2.5c5.26,9.29-12.46,42.24-13.22,43.64Zm9.24-46.52a5.8,5.8,0,0,0-4.42,2c-7.1,7.68-4.9,34.34-4.2,41.2,3.4-6.54,16.86-33.46,12.47-41.23a3.93,3.93,0,0,0-3.55-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.71,128.12s6.34-14.29,11.62-10.89S402.71,128.12,402.71,128.12Z",
    style: {
      fill: "#92E3A9"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M401.73,129.11l.52-1.19c.19-.41,4.55-10.14,9.24-11.54a3.65,3.65,0,0,1,3.12.42,2.29,2.29,0,0,1,1.24,2.16c-.3,3.9-11.64,9-12.94,9.62Zm10.9-11.91a2.85,2.85,0,0,0-.85.14c-3.33,1-6.69,7.09-8,9.75,3.89-1.86,10.9-5.7,11.09-8.2,0-.3,0-.76-.79-1.24A2.54,2.54,0,0,0,412.63,117.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-68--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.71,128.12s6.34-14.29,11.62-10.89S402.71,128.12,402.71,128.12Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.5,129.74s-13.42-8-9.41-12.85S391.5,129.74,391.5,129.74Z",
    style: {
      fill: "#92E3A9"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.36,130.83l-1.11-.66c-.39-.23-9.52-5.74-10.35-10.56a3.63,3.63,0,0,1,.8-3,2.31,2.31,0,0,1,2.3-1c3.83.77,7.57,12.65,8,14Zm-8.78-14.28a1.45,1.45,0,0,0-1.11.66,2.6,2.6,0,0,0-.58,2.23c.59,3.42,6.23,7.49,8.71,9.13-1.37-4.09-4.34-11.51-6.8-12Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-69--inject-53)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.5,129.74s-13.42-8-9.41-12.85S391.5,129.74,391.5,129.74Z",
    style: {
      opacity: 0.4
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.16,143.44c-.17-.21-2.4-4.87,3.76-8.87s7.83-1.33,11.45-3.8a21.15,21.15,0,0,1-5.62,10.77C397.84,146.73,393.86,144.25,393.16,143.44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M396.61,145.24h-.15a5.33,5.33,0,0,1-3.68-1.48,5.51,5.51,0,0,1-.59-3.59c.23-1.57,1.19-3.9,4.46-6a13.67,13.67,0,0,1,7.49-2.6,6.89,6.89,0,0,0,3.95-1.19l.92-.62-.14,1.1a21.72,21.72,0,0,1-5.76,11C400.5,144.64,398.16,145.24,396.61,145.24Zm-3.05-2.11a4.33,4.33,0,0,0,2.92,1.11c2,0,4-1,5.9-3a21.71,21.71,0,0,0,5.27-9.43,8.38,8.38,0,0,1-3.44.77,12.81,12.81,0,0,0-7,2.45C391.48,138.7,393.44,142.89,393.56,143.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.72,161.18c-7.32,6.25-29.87,22.81-31.49,20.9s18.27-21.57,25.59-27.81,14.58-9.76,16.21-7.85S387,154.94,379.72,161.18Z",
    style: {
      fill: "#92E3A9"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348.61,182.75a.88.88,0,0,1-.77-.35c-.45-.53-1.38-1.63,9.47-13,6-6.25,12.81-12.68,16.19-15.56a51.29,51.29,0,0,1,10.34-7c2.32-1.13,5.35-2.17,6.57-.74s-.29,4.25-1.77,6.36a51.11,51.11,0,0,1-8.59,9.1h0c-3.38,2.89-10.81,8.61-17.93,13.54C352.89,181.5,349.79,182.75,348.61,182.75Zm0-1h.14c2.85,0,21.89-13.49,30.64-20.95h0a50.1,50.1,0,0,0,8.42-8.91c2.06-2.95,2.3-4.59,1.83-5.14s-2.13-.58-5.37,1a50.34,50.34,0,0,0-10.13,6.91C365.25,162.24,348.5,179.38,348.62,181.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.09,141h5.55a0,0,0,0,1,0,0v8.59a.81.81,0,0,1-.81.81H388.9a.81.81,0,0,1-.81-.81V141A0,0,0,0,1,388.09,141Z",
    transform: "translate(248.05 -246.23) rotate(49.53)",
    style: {
      fill: "#858585"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18,151a1.31,1.31,0,0,1-1-.46h0l-2.55-3a1.3,1.3,0,0,1,.15-1.84l6.54-5.58a.49.49,0,0,1,.7.06l3.61,4.22a.52.52,0,0,1,.11.36.51.51,0,0,1-.17.35L390,150.72A1.3,1.3,0,0,1,389.18,151Zm-.23-1.11a.3.3,0,0,0,.43,0l6.16-5.25-3-3.46-6.16,5.25a.31.31,0,0,0,0,.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.37,130.77c-3.62,2.47-5.29-.21-11.45,3.8a12.53,12.53,0,0,0-1.71,1.32c-.26.47-.31.9,0,1.23,1.41,1.36,5.32-2.73,6.32-1.78s-1.69,2.25-.44,3.49-.81,2.89.34,3.9a13.75,13.75,0,0,0,1.29-1.19A21.15,21.15,0,0,0,408.37,130.77Z",
    style: {
      fill: "#92E3A9"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M401.45,143.39l-.32-.28c-.8-.71-.52-1.61-.3-2.34s.34-1.18-.06-1.58c-.95-.95-.27-2,.13-2.59s.45-.78.32-.9-1.44.55-2.08.92c-1.51.87-3.21,1.86-4.24.86a1.39,1.39,0,0,1-.13-1.83l.1-.13a13.16,13.16,0,0,1,1.78-1.37,13.67,13.67,0,0,1,7.49-2.6,6.89,6.89,0,0,0,3.95-1.19l.92-.62-.14,1.1a21.72,21.72,0,0,1-5.76,11,14.64,14.64,0,0,1-1.33,1.23Zm-.28-8.7a1,1,0,0,1,.74.29c.77.73.2,1.6-.17,2.17-.5.74-.59,1-.27,1.33a2.35,2.35,0,0,1,.32,2.59,2.77,2.77,0,0,0-.19.89c.28-.25.54-.5.78-.76a21.71,21.71,0,0,0,5.27-9.43,8.38,8.38,0,0,1-3.44.77,15,15,0,0,0-8.6,3.66c-.2.39-.08.51,0,.56.49.48,2-.38,3.05-1A6.11,6.11,0,0,1,401.17,134.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.71,134.72a1.88,1.88,0,0,0-2.24-1.49,2,2,0,0,0-1.51,2.28l.23,1.19a1.88,1.88,0,0,0,2.24,1.48,2,2,0,0,0,1.51-2.28Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,138.72a2.33,2.33,0,0,1-1.3-.39,2.4,2.4,0,0,1-1-1.54l-.23-1.18a2.46,2.46,0,0,1,1.9-2.86,2.32,2.32,0,0,1,1.81.34,2.36,2.36,0,0,1,1,1.53h0l.23,1.19a2.47,2.47,0,0,1-1.89,2.86A2.21,2.21,0,0,1,201,138.72Zm-.16-5a1.36,1.36,0,0,0-.29,0,1.48,1.48,0,0,0-1.13,1.7l.24,1.18a1.38,1.38,0,0,0,1.64,1.09,1.45,1.45,0,0,0,1.12-1.69l-.23-1.19a1.38,1.38,0,0,0-1.35-1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.93,142.8l1,5.3a1,1,0,0,0,1.1.84,1,1,0,0,0,.9-1.23l-.87-4.48a.42.42,0,0,1,.32-.49h0a.39.39,0,0,1,.48.31l3.52,18.1a1.24,1.24,0,0,0,1.49,1h0a1.3,1.3,0,0,0,1-1.51L203,151a.92.92,0,0,1,.63-1.07.85.85,0,0,1,1.06.66l1.87,9.65a1.25,1.25,0,0,0,1.5,1h0a1.29,1.29,0,0,0,1-1.52l-3.51-18.09a.42.42,0,0,1,.32-.49h0a.41.41,0,0,1,.48.32l.86,4.45a1,1,0,1,0,2-.38l-1-5.34a2.53,2.53,0,0,0-3-2L198,139.72A2.65,2.65,0,0,0,195.93,142.8Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.63,162.66a1.74,1.74,0,0,1-1.71-1.42l-2.5-12.89a1.4,1.4,0,0,1-.24.47,1.51,1.51,0,0,1-2.71-.63l-1-5.29a3.15,3.15,0,0,1,2.42-3.67l7.23-1.53a3,3,0,0,1,3.62,2.4l1,5.33a1.55,1.55,0,0,1-.27,1.2,1.52,1.52,0,0,1-1.07.62,1.46,1.46,0,0,1-1.33-.57l2.51,12.95a1.8,1.8,0,0,1-1.39,2.1,1.73,1.73,0,0,1-1.33-.25,1.76,1.76,0,0,1-.76-1.13l-1.87-9.65a.35.35,0,0,0-.16-.23.34.34,0,0,0-.28,0,.42.42,0,0,0-.27.49l1.87,9.6a1.81,1.81,0,0,1-1.39,2.1A1.64,1.64,0,0,1,203.63,162.66Zm-5.13-20.43a.89.89,0,0,1,.5.15.91.91,0,0,1,.39.58l3.51,18.09a.75.75,0,0,0,.32.49.79.79,0,0,0,.58.11.81.81,0,0,0,.62-.94l-1.87-9.6a1.42,1.42,0,0,1,1-1.65,1.39,1.39,0,0,1,1.07.16,1.34,1.34,0,0,1,.61.89l1.88,9.65a.74.74,0,0,0,.32.49.72.72,0,0,0,.57.1.79.79,0,0,0,.62-.93l-3.51-18.09a.93.93,0,0,1,.71-1.08.9.9,0,0,1,1.07.72l.87,4.44a.52.52,0,0,0,.55.45.55.55,0,0,0,.37-.22.53.53,0,0,0,.1-.42l-1-5.33a2,2,0,0,0-.87-1.32,2,2,0,0,0-1.56-.29l-7.23,1.53a2.15,2.15,0,0,0-1.65,2.5h0l1,5.29a.53.53,0,0,0,.55.45.57.57,0,0,0,.38-.22.56.56,0,0,0,.09-.42l-.87-4.49a.91.91,0,0,1,.71-1.07A.62.62,0,0,1,198.5,142.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.57,169.05l3.83-4.22c1.29-1.43,3.39-1.91,4.69-1.07s1.66,2.92.83,4.65l-2.47,5.11Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.45,174a.53.53,0,0,1-.27-.08l-6.89-4.47a.51.51,0,0,1-.22-.36.5.5,0,0,1,.13-.4l3.83-4.22c1.47-1.63,3.82-2.13,5.33-1.15s1.94,3.34,1,5.29c-.17.34-2.47,5.11-2.47,5.11a.48.48,0,0,1-.31.26ZM399.33,169l5.92,3.84,2.21-4.6c.73-1.5.44-3.3-.65-4s-2.93-.25-4,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.8,176.09l-11.17-7.25a4.76,4.76,0,0,0-6.52,1.32l-5.43,8.05a1.85,1.85,0,0,0,.32,2.49,1.89,1.89,0,0,0,2.72-.42l4.61-6.83a.75.75,0,0,1,1-.21h0a.72.72,0,0,1,.21,1l-5.8,8.59-7.72,6.75,2.2,1.43L374,201.78a2.26,2.26,0,0,0,.64,3.16,2.36,2.36,0,0,0,3.22-.65l7.25-10.75,2.62,1.7L380.48,206a2.26,2.26,0,0,0,.64,3.16,2.35,2.35,0,0,0,3.22-.66l7.25-10.74,2.21,1.43,3.31-9.62,5.8-8.59a.75.75,0,0,1,1-.21.73.73,0,0,1,.21,1l-4.56,6.76a1.85,1.85,0,0,0,.32,2.49,1.89,1.89,0,0,0,2.72-.42l5.47-8.11A4.57,4.57,0,0,0,406.8,176.09Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,210a2.79,2.79,0,0,1-1.54-.45,2.76,2.76,0,0,1-.78-3.86l7-10.33-1.78-1.15-7,10.34a2.85,2.85,0,0,1-3.9.79,2.69,2.69,0,0,1-1.2-1.76,2.75,2.75,0,0,1,.42-2.1l7-10.32L378.77,190a.5.5,0,0,1-.22-.38.52.52,0,0,1,.17-.42l7.68-6.7,5.76-8.54a.23.23,0,0,0,0-.17.25.25,0,0,0-.1-.15.27.27,0,0,0-.35.07l-4.61,6.83a2.34,2.34,0,1,1-3.87-2.63l5.44-8.05a5.27,5.27,0,0,1,7.2-1.46l11.17,7.25h0a5.06,5.06,0,0,1,1.44,7.11L403,190.89a2.4,2.4,0,0,1-1.61,1,2.33,2.33,0,0,1-2.26-3.65l4.56-6.76a.21.21,0,0,0,0-.17.25.25,0,0,0-.1-.15.26.26,0,0,0-.35.07l-5.76,8.54-3.29,9.55a.5.5,0,0,1-.31.31.52.52,0,0,1-.44-.05l-1.79-1.17-7,10.34A2.84,2.84,0,0,1,382.39,210Zm2.72-17a.45.45,0,0,1,.27.08l2.62,1.7a.47.47,0,0,1,.22.32.51.51,0,0,1-.07.38l-7.26,10.75a1.76,1.76,0,0,0-.26,1.34,1.72,1.72,0,0,0,.76,1.12,1.86,1.86,0,0,0,2.53-.51l7.25-10.75a.5.5,0,0,1,.69-.14l1.67,1.08,3.11-9a.34.34,0,0,1,.06-.12l5.79-8.59a1.26,1.26,0,0,1,1.72-.35,1.23,1.23,0,0,1,.54.79,1.19,1.19,0,0,1-.19.93L400,188.82a1.34,1.34,0,1,0,2.21,1.51l5.48-8.11a4.08,4.08,0,0,0-1.16-5.71l-11.17-7.25a4.27,4.27,0,0,0-5.84,1.18l-5.43,8.05a1.32,1.32,0,0,0,1.29,2.1,1.4,1.4,0,0,0,.93-.59l4.6-6.83a1.27,1.27,0,0,1,1.73-.35,1.25,1.25,0,0,1,.35,1.72l-5.8,8.59-.09.1-7.23,6.31,1.66,1.07a.52.52,0,0,1,.14.7l-7.25,10.75a1.73,1.73,0,0,0-.27,1.34,1.7,1.7,0,0,0,.77,1.12,1.85,1.85,0,0,0,2.52-.51l7.26-10.75A.49.49,0,0,1,385.11,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.66,130.16A16.08,16.08,0,0,1,319,124a12.82,12.82,0,0,0,25.28,0A16.08,16.08,0,0,1,331.66,130.16Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.66,135.2a13.3,13.3,0,0,1-13.14-11.09.5.5,0,0,1,.29-.54.51.51,0,0,1,.6.15,15.6,15.6,0,0,0,24.5,0,.5.5,0,0,1,.88.39A13.28,13.28,0,0,1,331.66,135.2ZM320,125.87a12.33,12.33,0,0,0,23.32,0,16.59,16.59,0,0,1-23.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.6,112.22a10.84,10.84,0,0,1,4.14-8.53,8.65,8.65,0,0,0,0,17.06A10.86,10.86,0,0,1,314.6,112.22Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,121.25h-.08a9.15,9.15,0,0,1,0-18,.5.5,0,0,1,.54.29.51.51,0,0,1-.15.6,10.36,10.36,0,0,0,0,16.28.5.5,0,0,1,.15.59A.51.51,0,0,1,318.74,121.25Zm-1.84-16.49a8.16,8.16,0,0,0,0,14.92,11.34,11.34,0,0,1,0-14.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.29,144.75a10.83,10.83,0,0,1-3.11-8.95,8.65,8.65,0,0,0,12.06,12.06A10.84,10.84,0,0,1,305.29,144.75Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.24,150a9.15,9.15,0,0,1-7.47-14.45.5.5,0,0,1,.59-.18.51.51,0,0,1,.32.52,10.34,10.34,0,0,0,3,8.55h0a10.34,10.34,0,0,0,8.55,3,.49.49,0,0,1,.52.32.5.5,0,0,1-.18.59A9.09,9.09,0,0,1,309.24,150Zm-7.61-12.1a8.16,8.16,0,0,0,10.55,10.55,11.32,11.32,0,0,1-7.25-3.3h0A11.37,11.37,0,0,1,301.63,137.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,160.6a7.76,7.76,0,0,1-6.06-2.94,6.15,6.15,0,0,0,12.12,0A7.73,7.73,0,0,1,288.83,160.6Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,163.27a6.63,6.63,0,0,1-6.55-5.53.5.5,0,0,1,.29-.54.51.51,0,0,1,.6.15,7.21,7.21,0,0,0,11.33,0,.51.51,0,0,1,.6-.15.5.5,0,0,1,.29.54A6.63,6.63,0,0,1,288.83,163.27ZM284,159.5a5.66,5.66,0,0,0,9.73,0,8.2,8.2,0,0,1-9.73,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48,165.61a6.18,6.18,0,0,1-4.87-2.36,4.94,4.94,0,0,0,9.74,0A6.2,6.2,0,0,1,243.48,165.61Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48,167.86a5.43,5.43,0,0,1-5.37-4.52.54.54,0,0,1,.29-.55.51.51,0,0,1,.6.15,5.71,5.71,0,0,0,9,0,.5.5,0,0,1,.59-.15.51.51,0,0,1,.29.55A5.42,5.42,0,0,1,243.48,167.86Zm-3.55-2.76a4.46,4.46,0,0,0,7.1,0A6.88,6.88,0,0,1,239.93,165.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.57,144.74a6.23,6.23,0,0,1,2.36-4.87,4.95,4.95,0,0,0,0,9.75A6.23,6.23,0,0,1,284.57,144.74Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.93,150.12h-.08a5.44,5.44,0,0,1,0-10.73.49.49,0,0,1,.54.29.52.52,0,0,1-.14.6,5.68,5.68,0,0,0,0,8.95.52.52,0,0,1,.14.6A.51.51,0,0,1,286.93,150.12Zm-1.85-8.92a4.44,4.44,0,0,0,0,7.09,6.65,6.65,0,0,1-1-3.55A6.72,6.72,0,0,1,285.08,141.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.16 100.83 372.55 96.42 370.95 105.77 377.74 112.38 368.36 113.75 364.16 122.25 359.96 113.75 350.58 112.38 357.37 105.77 355.77 96.42 364.16 100.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,122.75a.5.5,0,0,1-.45-.28l-4.08-8.27-9.12-1.32a.51.51,0,0,1-.41-.34.49.49,0,0,1,.13-.51l6.6-6.44-1.56-9.09a.5.5,0,0,1,.2-.48.49.49,0,0,1,.53,0l8.16,4.29L372.32,96a.49.49,0,0,1,.53,0,.48.48,0,0,1,.19.48l-1.55,9.09,6.6,6.44a.5.5,0,0,1,.12.51.49.49,0,0,1-.4.34l-9.12,1.32-4.08,8.27A.51.51,0,0,1,364.16,122.75ZM351.65,112l8.39,1.22a.51.51,0,0,1,.37.28l3.75,7.59,3.75-7.59a.51.51,0,0,1,.37-.28l8.39-1.22-6.07-5.91a.48.48,0,0,1-.14-.44l1.43-8.35-7.5,3.94a.47.47,0,0,1-.46,0l-7.5-3.94,1.43,8.35a.48.48,0,0,1-.14.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.1 98.71 371.49 94.3 369.89 103.64 376.68 110.26 367.29 111.62 363.1 120.13 358.9 111.62 349.52 110.26 356.31 103.64 354.7 94.3 363.1 98.71",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1,120.63a.5.5,0,0,1-.45-.28l-4.08-8.27-9.13-1.33a.48.48,0,0,1-.4-.34.49.49,0,0,1,.13-.51l6.6-6.43-1.56-9.09a.51.51,0,0,1,.2-.49.53.53,0,0,1,.53,0l8.16,4.29,8.16-4.29a.51.51,0,0,1,.52,0,.47.47,0,0,1,.2.49l-1.56,9.09L377,109.9a.51.51,0,0,1,.12.51.47.47,0,0,1-.4.34l-9.12,1.33-4.08,8.27A.51.51,0,0,1,363.1,120.63Zm-12.51-10.72,8.38,1.22a.49.49,0,0,1,.38.27l3.75,7.6,3.75-7.6a.47.47,0,0,1,.37-.27l8.38-1.22L369.54,104a.52.52,0,0,1-.15-.44l1.44-8.35-7.5,3.94a.47.47,0,0,1-.46,0l-7.5-3.94,1.43,8.35a.52.52,0,0,1-.14.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.16 88.88 338.76 90.93 333.12 94.92 333.21 101.84 327.67 97.7 321.12 99.92 323.34 93.38 319.2 87.83 326.12 87.92 330.11 82.28 332.16 88.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.21,102.34a.54.54,0,0,1-.3-.1l-5.33-4-6.3,2.14a.5.5,0,0,1-.64-.64l2.14-6.3-4-5.33a.51.51,0,0,1,.4-.8h0l6.65.09L329.7,82a.5.5,0,0,1,.49-.21.51.51,0,0,1,.4.35l2,6.35,6.35,2a.53.53,0,0,1,.35.4.5.5,0,0,1-.21.49l-5.43,3.84.09,6.65a.5.5,0,0,1-.28.45A.46.46,0,0,1,333.21,102.34Zm-5.54-5.14a.51.51,0,0,1,.29.1l4.73,3.53-.07-5.9a.51.51,0,0,1,.21-.41l4.82-3.41L332,89.36a.54.54,0,0,1-.33-.33l-1.75-5.64-3.41,4.82a.49.49,0,0,1-.4.21h0l-5.9-.07,3.53,4.73a.5.5,0,0,1,.07.46l-1.89,5.58,5.58-1.89A.51.51,0,0,1,327.67,97.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.71 87.24 339.31 89.29 333.67 93.28 333.75 100.2 328.21 96.06 321.66 98.28 323.88 91.73 319.75 86.19 326.66 86.28 330.66 80.63 332.71 87.24",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.75,100.7a.51.51,0,0,1-.29-.1l-5.34-4-6.3,2.13a.47.47,0,0,1-.51-.12.5.5,0,0,1-.12-.51l2.14-6.3-4-5.33a.51.51,0,0,1-.05-.53.52.52,0,0,1,.45-.27h0l6.65.09,3.84-5.44a.5.5,0,0,1,.48-.2.49.49,0,0,1,.4.34l2,6.36,6.35,2a.51.51,0,0,1,.35.4.5.5,0,0,1-.21.49l-5.43,3.84.08,6.65a.47.47,0,0,1-.27.45A.46.46,0,0,1,333.75,100.7Zm-5.54-5.14a.47.47,0,0,1,.3.1l4.73,3.53-.07-5.9a.48.48,0,0,1,.21-.42l4.82-3.4-5.64-1.76a.48.48,0,0,1-.33-.33l-1.75-5.63-3.41,4.82a.49.49,0,0,1-.41.21h0l-5.9-.08,3.53,4.73a.54.54,0,0,1,.07.46l-1.9,5.59,5.59-1.89A.45.45,0,0,1,328.21,95.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.58 150.66 307.1 148.82 306.43 152.73 309.27 155.5 305.34 156.07 303.58 159.63 301.82 156.07 297.9 155.5 300.74 152.73 300.07 148.82 303.58 150.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.58,160.13a.51.51,0,0,1-.45-.28l-1.64-3.32-3.67-.53a.51.51,0,0,1-.4-.35.49.49,0,0,1,.13-.51l2.65-2.58-.62-3.66a.49.49,0,0,1,.19-.49.51.51,0,0,1,.53,0l3.28,1.72,3.28-1.72a.51.51,0,0,1,.53,0,.51.51,0,0,1,.2.49l-.63,3.66,2.66,2.58a.51.51,0,0,1,.12.51.5.5,0,0,1-.4.35l-3.67.53L304,159.85A.5.5,0,0,1,303.58,160.13Zm-4.61-5,2.93.43a.47.47,0,0,1,.37.27l1.31,2.65,1.31-2.65a.47.47,0,0,1,.38-.27l2.92-.43-2.11-2.06a.49.49,0,0,1-.15-.44l.5-2.92-2.62,1.38a.53.53,0,0,1-.46,0l-2.62-1.38.5,2.92a.49.49,0,0,1-.14.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.14 149.78 306.65 147.93 305.98 151.84 308.82 154.61 304.89 155.18 303.14 158.74 301.38 155.18 297.45 154.61 300.3 151.84 299.62 147.93 303.14 149.78",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.14,159.24a.5.5,0,0,1-.45-.28l-1.64-3.32-3.67-.53a.5.5,0,0,1-.4-.34.53.53,0,0,1,.12-.52l2.66-2.58-.63-3.66a.53.53,0,0,1,.2-.49.51.51,0,0,1,.53,0l3.28,1.72,3.28-1.72a.51.51,0,0,1,.53,0,.5.5,0,0,1,.19.49l-.62,3.66,2.65,2.58a.51.51,0,0,1,.13.52.51.51,0,0,1-.4.34l-3.67.53L303.59,159A.51.51,0,0,1,303.14,159.24Zm-4.61-5,2.92.43a.47.47,0,0,1,.38.27l1.31,2.65,1.31-2.65a.47.47,0,0,1,.37-.27l2.93-.43-2.12-2.06a.49.49,0,0,1-.14-.44l.5-2.92-2.62,1.38a.53.53,0,0,1-.46,0l-2.62-1.38.5,2.92a.49.49,0,0,1-.15.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.99 147.67 251.96 146.11 251.4 149.42 253.8 151.76 250.48 152.24 248.99 155.25 247.51 152.24 244.19 151.76 246.59 149.42 246.02 146.11 248.99 147.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,155.75h0a.51.51,0,0,1-.45-.28l-1.36-2.77-3.07-.45a.5.5,0,0,1-.4-.34.49.49,0,0,1,.13-.51l2.21-2.16-.52-3.05a.48.48,0,0,1,.2-.48.47.47,0,0,1,.52,0l2.74,1.44,2.74-1.44a.49.49,0,0,1,.53,0,.5.5,0,0,1,.2.48l-.53,3.05,2.22,2.16a.5.5,0,0,1,.12.51.47.47,0,0,1-.4.34l-3.06.45-1.37,2.77A.5.5,0,0,1,249,155.75Zm-3.73-4.34,2.32.34a.5.5,0,0,1,.38.27l1,2.1,1-2.1a.47.47,0,0,1,.38-.27l2.31-.34-1.67-1.64a.51.51,0,0,1-.15-.44l.4-2.31-2.07,1.09a.49.49,0,0,1-.47,0L246.69,147l.39,2.31a.48.48,0,0,1-.14.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.62 146.92 251.59 145.36 251.02 148.66 253.42 151.01 250.1 151.49 248.62 154.5 247.13 151.49 243.81 151.01 246.21 148.66 245.65 145.36 248.62 146.92",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.62,155a.5.5,0,0,1-.45-.28L246.8,152l-3.06-.45a.47.47,0,0,1-.4-.34.5.5,0,0,1,.12-.51l2.22-2.16-.53-3.05a.5.5,0,0,1,.73-.52l2.74,1.43,2.73-1.43a.51.51,0,0,1,.53,0,.49.49,0,0,1,.2.49l-.52,3.05,2.21,2.16a.49.49,0,0,1,.13.51.5.5,0,0,1-.4.34l-3.07.45-1.36,2.77A.51.51,0,0,1,248.62,155Zm-3.73-4.34,2.31.34a.47.47,0,0,1,.38.27l1,2.1,1-2.1A.5.5,0,0,1,250,151l2.32-.34L250.67,149a.48.48,0,0,1-.14-.44l.39-2.31-2.07,1.09a.49.49,0,0,1-.47,0l-2.07-1.09.4,2.31a.51.51,0,0,1-.15.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.81 182.07 299.98 185.39 300.26 186.75 337.55 196.12 336.28 194.51 337.11 191.19 338.99 190.37 301.7 181 300.81 182.07",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,196.62h-.13l-37.29-9.37a.5.5,0,0,1-.36-.39l-.28-1.36a.54.54,0,0,1,0-.22l.84-3.32a.42.42,0,0,1,.1-.2l.89-1.07a.49.49,0,0,1,.51-.16l37.28,9.36a.5.5,0,0,1,.38.45.48.48,0,0,1-.3.49l-1.66.73-.71,2.84,1.12,1.42a.51.51,0,0,1,0,.58A.51.51,0,0,1,337.55,196.62Zm-36.87-10.27,35.57,8.93-.37-.47a.51.51,0,0,1-.09-.43l.83-3.31a.52.52,0,0,1,.29-.34l.54-.23-35.56-8.94-.62.75-.78,3.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.94 194.92 338.99 190.37 337.09 190.42 335.58 194.45 336.65 195.9 337.55 196.12 344.94 194.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.55,196.62h-.13l-.9-.23a.49.49,0,0,1-.28-.19l-1.06-1.44a.5.5,0,0,1-.07-.47l1.51-4a.48.48,0,0,1,.45-.32l1.91,0a.6.6,0,0,1,.32.1l5.95,4.55a.5.5,0,0,1,.18.52.49.49,0,0,1-.41.37l-7.39,1.21Zm-.61-1.17.63.16,6.15-1-4.89-3.74-1.39,0-1.3,3.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.88,193.34a3.48,3.48,0,0,0-.41,1,3.41,3.41,0,0,0-.09,1l2.56-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.38,195.84a.51.51,0,0,1-.31-.11.52.52,0,0,1-.19-.36,3.63,3.63,0,0,1,.11-1.19,3.55,3.55,0,0,1,.47-1.1.55.55,0,0,1,.33-.23.52.52,0,0,1,.4.1l2.06,1.57a.5.5,0,0,1,.18.52.49.49,0,0,1-.41.37l-2.56.42Zm.68-1.73a1.12,1.12,0,0,0-.1.31c0,.11,0,.22-.07.33l.83-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.25,180.38a.44.44,0,0,1-.15,0,.49.49,0,0,1-.32-.62c.86-2.75,1.67-4.33,2.53-5a.51.51,0,0,1,.7.11.5.5,0,0,1-.1.7c-.67.49-1.4,2-2.18,4.46A.5.5,0,0,1,371.25,180.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.25,204.16a1.43,1.43,0,0,1-.29,0,1.75,1.75,0,0,1-1.19-.82c-1-1.72.21-5.86,1.42-9.86.69-2.3,1.86-6.16,1.31-6.51-.33-.21-1.1.1-2.07.85a.51.51,0,0,1-.7-.1.5.5,0,0,1,.09-.7c1.41-1.08,2.46-1.38,3.21-.9,1.14.73.44,3.25-.89,7.65-1,3.44-2.33,7.71-1.51,9a.73.73,0,0,0,.51.36c1.66.3,3.6-6.25,5-11,2.1-7,3.52-11.31,5.57-11.68a1.41,1.41,0,0,1,1.26.34c1.2,1.13.91,4.61.34,9.78-.34,3-.76,6.72-.16,7.39h0c1.06,0,2.54-6.19,3.52-10.29.42-1.74.84-3.51,1.28-5.16a.5.5,0,0,1,1,.26c-.44,1.64-.86,3.4-1.27,5.13C368,195,366.94,199,365.23,199a1.07,1.07,0,0,1-.81-.36c-.85-1-.59-3.73-.09-8.17.4-3.6.91-8.07,0-8.93a.42.42,0,0,0-.4-.1c-1.6.29-3.37,6.22-4.79,11C357.24,198.69,355.61,204.16,353.25,204.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.28,189.55a.46.46,0,0,1-.35-.14.5.5,0,0,1,0-.71l.87-.83a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71c-.28.25-.55.52-.83.8A.5.5,0,0,1,350.28,189.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.68,193.71a.49.49,0,0,1-.39-.8s.86-1.14,2-2.47a.5.5,0,0,1,.7,0,.49.49,0,0,1,.05.7c-1.13,1.3-2,2.4-2,2.41A.51.51,0,0,1,346.68,193.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.11,
    y: 145.8,
    width: 52.91,
    height: 16.36,
    transform: "translate(-19.3 253.36) rotate(-38.95)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.14,177.47a.51.51,0,0,1-.39-.19l-10.28-12.72a.45.45,0,0,1-.11-.37.48.48,0,0,1,.18-.33l41.15-33.27a.49.49,0,0,1,.7.08l10.29,12.72a.53.53,0,0,1,.11.37.49.49,0,0,1-.19.33l-41.15,33.27A.51.51,0,0,1,333.14,177.47Zm-9.58-13.15,9.65,11.94,40.37-32.63-9.65-11.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.69,
    y: 153.07,
    width: 52.91,
    height: 8.18,
    transform: "translate(-20.73 255.69) rotate(-38.95)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.14,177.47a.51.51,0,0,1-.39-.19l-5.14-6.36a.49.49,0,0,1,.07-.7L368.83,137a.5.5,0,0,1,.37-.1.52.52,0,0,1,.34.18l5.14,6.36a.5.5,0,0,1-.08.7l-41.15,33.27A.51.51,0,0,1,333.14,177.47Zm-4.44-6.79,4.51,5.58,40.37-32.63-4.51-5.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.29,166.59a.5.5,0,0,1-.39-.18l-3-3.78a.5.5,0,1,1,.78-.62l3.05,3.77a.5.5,0,0,1-.08.7A.45.45,0,0,1,328.29,166.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.26,162.92a.51.51,0,0,1-.39-.19l-1.64-2a.5.5,0,0,1,.78-.63l1.64,2a.5.5,0,0,1-.39.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64,161a.51.51,0,0,1-.39-.18l-1.63-2a.5.5,0,1,1,.77-.63l1.64,2a.5.5,0,0,1-.07.7A.56.56,0,0,1,331.64,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,159.06a.51.51,0,0,1-.39-.18l-1.63-2a.52.52,0,0,1,.07-.71.51.51,0,0,1,.71.08l1.63,2a.49.49,0,0,1-.07.7A.48.48,0,0,1,334,159.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.41,157.14A.51.51,0,0,1,336,157l-1.64-2a.49.49,0,0,1,.08-.7.49.49,0,0,1,.7.07l1.63,2a.5.5,0,0,1-.07.71A.51.51,0,0,1,336.41,157.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.2,157a.49.49,0,0,1-.39-.19l-3-3.77a.49.49,0,0,1,.07-.7.49.49,0,0,1,.7.07l3,3.77a.51.51,0,0,1-.07.71A.56.56,0,0,1,340.2,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.17,153.28a.51.51,0,0,1-.39-.18l-1.63-2a.5.5,0,1,1,.78-.63l1.63,2a.49.49,0,0,1-.39.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.56,151.36a.51.51,0,0,1-.39-.19l-1.64-2a.5.5,0,0,1,.78-.63l1.64,2a.5.5,0,0,1-.39.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.94,149.43a.5.5,0,0,1-.39-.18l-1.63-2a.49.49,0,0,1,.07-.7.5.5,0,0,1,.7.07l1.64,2a.5.5,0,0,1-.08.7A.45.45,0,0,1,345.94,149.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.32,147.5a.51.51,0,0,1-.39-.18l-1.63-2a.5.5,0,1,1,.78-.63l1.63,2a.49.49,0,0,1-.39.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.12,147.33a.51.51,0,0,1-.39-.19l-3.05-3.77a.5.5,0,0,1,.78-.63l3.05,3.77a.5.5,0,0,1-.39.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.09,143.65a.5.5,0,0,1-.39-.18l-1.64-2a.5.5,0,0,1,.08-.7.5.5,0,0,1,.7.07l1.64,2a.5.5,0,0,1-.08.7A.45.45,0,0,1,353.09,143.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.47,141.73a.52.52,0,0,1-.39-.19l-1.63-2a.5.5,0,1,1,.78-.63l1.63,2a.49.49,0,0,1-.07.7A.51.51,0,0,1,355.47,141.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.86,139.8a.48.48,0,0,1-.39-.19l-1.64-2a.5.5,0,0,1,.78-.63l1.63,2a.5.5,0,0,1-.38.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.24,137.87a.5.5,0,0,1-.39-.18l-1.64-2a.5.5,0,0,1,.08-.7.5.5,0,0,1,.7.07l1.64,2a.5.5,0,0,1-.08.7A.45.45,0,0,1,360.24,137.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,137.69a.5.5,0,0,1-.39-.18l-3-3.77a.5.5,0,1,1,.78-.63l3,3.77a.49.49,0,0,1-.07.7A.45.45,0,0,1,364,137.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.93 168.56 162.98 181.83 152.88 181.83 157.93 168.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,182.33h-10.1a.49.49,0,0,1-.41-.22.5.5,0,0,1-.06-.46l5.05-13.26a.52.52,0,0,1,.94,0l5,13.26a.5.5,0,0,1-.05.46A.49.49,0,0,1,163,182.33Zm-9.37-1h8.64L157.93,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.6 170.24 164.65 183.5 154.55 183.5 159.6 170.24",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.65,184h-10.1a.5.5,0,0,1-.41-.22.5.5,0,0,1,0-.46l5-13.26a.52.52,0,0,1,.93,0l5.05,13.26a.47.47,0,0,1-.06.46A.48.48,0,0,1,164.65,184Zm-9.37-1h8.65l-4.33-11.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.4 177.83 309.43 170.22 317.52 164.18 321.4 177.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4,178.33a.54.54,0,0,1-.27-.07l-12-7.62a.51.51,0,0,1-.23-.4.49.49,0,0,1,.2-.42l8.09-6a.51.51,0,0,1,.46-.07.48.48,0,0,1,.32.34l3.88,13.65a.5.5,0,0,1-.48.63Zm-11.09-8.14,10.25,6.52L317.24,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.06 177.49 307.09 169.88 315.18 163.84 319.06 177.49",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,178a.45.45,0,0,1-.27-.08l-12-7.61a.5.5,0,0,1,0-.82l8.09-6a.5.5,0,0,1,.78.27l3.88,13.65a.5.5,0,0,1-.48.63ZM308,169.84l10.25,6.53-3.32-11.69Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.dea51ecfd85b60f51e67df7532e60114.svg";
export { ForwardRef as ReactComponent };